<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-09-30 15:25:16
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-23 16:50:37
-->
<template>
  <div>
    <a-spin :spinning="loadingBox" :tip="loadingBoxTwo?'数据处理中请稍等':''">
      <div class="wrapper" v-if="isLodaing">
        <div class="top">
          <div class="back" @click="toBack">
            <a-icon type="arrow-left"/>
          </div>
          编辑稿件
          <!--      <Toolbar-->
          <!--        style="padding: 5px 0px"-->
          <!--        :editor="editor"-->
          <!--        :defaultConfig="toolbarConfig"-->
          <!--        :mode="mode"-->
          <!--      />-->
        </div>
        <div class="content-box">
          <div class="content" :style="{ height: height }">
            <div class="left">
              <div v-if="codeData.indexOf('266') != -1" class="btn-item" @click="openImport(1)">
                <span class="icon-edit-word"></span>
                word导入
              </div>
              <div v-if="codeData.indexOf('267') != -1" class="btn-item" @click="openImport(2)">
                <span class="icon-edit-excel"></span>
                Excel导入
              </div>
              <div v-if="codeData.indexOf('268') != -1" class="btn-item" @click="openImport(3)">
                <span class="icon-edit-pdf"></span>
                PDF导入
              </div>
              <div v-if="codeData.indexOf('269') != -1" class="btn-item" @click="openImport(4)">
                <span class="icon-edit-ppt"></span>
                PPT导入
              </div>
              <div v-if="codeData.indexOf('270') != -1" @click="linkImport" class="btn-item">
                <span class="icon-edit-url"></span>
                链接导入
              </div>
              <div v-if="codeData.indexOf('271') != -1" class="btn-item" @click="openMisse">
                <span class="icon-edit-wrong"></span>
                错敏检测
              </div>
              <div v-if="codeData.indexOf('272') != -1" @click="openDarkLink" class="btn-item">
                <span class="icon-edit-unlink"></span>
                暗链检测
              </div>
<!--              <div v-if="codeData.indexOf('441') != -1" class="btn-item" @click="openTempModal">-->
<!--                <span class="ri-layout-masonry-line"></span>-->
<!--                选择模板-->
<!--              </div>-->
              <div v-if="codeData.indexOf('273') != -1" class="btn-item" @click="toHistory">
                <span class="icon-edit-history"></span>
                历史版本
              </div>
            </div>
            <div class="middle">
              <div id="zaiYao" class="middle-box">
                <div class="t-title">
                  <div class="title" id="article">
                    <el-input
                        v-model="title"
                        placeholder="请输入文章标题"
                    ></el-input>
                  </div>
                  <div class="info">
                    <div class="block">
                      &emsp;发布时间：
                      <el-date-picker
                          v-model="createTime"
                          type="datetime"
                          placeholder="年/月/日 --:--"
                          :pickerOptions="{
                            disabledDate(time) {
                              return time.getTime() > Date.now();
                            }
                          }"
                      >
                      </el-date-picker>
                    </div>
                    <div class="lai-yuan" style="display: flex; align-items: center">
                      <span class="icon-file-code"></span>&emsp; 来源：
                      <el-input
                          v-model="source"
                          placeholder="请填写文章来源"
                      ></el-input>
                    </div>
                  </div>
                  <div class="abstract">
                    <el-input
                        v-model="abstractText"
                        placeholder="摘要(选填)"
                    ></el-input>
                  </div>
                </div>
                <uEditorWrap v-model="htmlContent"
                             @ready="ueditorReady"
                             editor-id="ueditor"
                             :config="uEditorConfig"
                             :editorDependencies="['ueditor.config.js','ueditor.all.js']"
                              class="editor-box" />
                <!--            <Editor-->
                <!--              style="height: 500px; overflow-y: hidden; padding: 10px 62px"-->
                <!--              v-model="htmlContent"-->
                <!--              :defaultConfig="editorConfig"-->
                <!--              :defaultContent="jsonContent"-->
                <!--              :mode="mode"-->
                <!--              @onCreated="onCreated"-->
                <!--            />-->
                <div class="setup" id="setup">
                  <div style="border-bottom: 1px solid #eeebeb">
                    <div class="set-title">
                      <div id="faWenSet" class="line"></div>
                      发文设置
                      <div class="line"></div>
                    </div>
                    <div class="form-box">
                      <el-form ref="form" label-width="100px">
                        <el-form-item label="发布至栏目">
                          <el-button @click="openChooseColumn"
                          >+添加至栏目
                          </el-button
                          >
                          <div style="font-size: 12px; color: #909399">
                            添加栏目后请在右侧补齐栏目字段
                          </div>
                          <div>
                            <div
                                v-for="(item, index) in columnData"
                                class="one"
                                :key="index"
                            >
                              <div class="name"><span :title="item.columnName">{{ item.columnName }}</span></div>
                              &emsp;
                              <span
                                  @click="deleteFn(index, item.columnId || item.id)"
                                  class="icon-close"
                              ></span>
                            </div>
                          </div>
                        </el-form-item>
                        <el-form-item label="展示封面">
                          <div style="display: flex">
                            <div
                                class="one-box one-box-two"
                                @click="openChooseCover"
                            >
                              <div v-if="!coverImg">
                                <span class="icon-plus"></span>
                                <div class="text">点击上传图片</div>
                              </div>
                              <div  class="img-box" v-if="coverImg">
                                <div class="semi-close" @click.stop="deleteImg">
                                  <span class="icon-semi-close"></span>
                                </div>
                                <img class="add-img" :src="imgIp + coverImg"/>
                                <div class="edit-image" @click="toEditImg">
                                  替换 编辑
                                </div>
                              </div>
                            </div>
                            <!-- <div class="one-box one-box-two" v-for="(item,index) in coverImgList" :key="index">
                                            <div class="semi-close" @click="deleteImg(item,index)">
                                                <span class="icon-semi-close"></span>
                                            </div>
                                            <img class="add-img" :src="imgIp +item" />
                                            <div class="edit-image" @click="toEditImg(item,index)">替换 编辑</div>
                                        </div> -->
                          </div>
                          <div
                              style="font-size: 12px; margin-top: 0px; color: #909399"
                          >
                            支持20MB以内的jpg、png图片
                          </div>
                        </el-form-item>
                        <el-form-item class="link-box" label="相关链接">
                          <el-button @click="openChooseLink">+添加链接</el-button>
                          <div>
                            <div
                                v-for="(item, index) in LinkInfo"
                                class="one"
                                :key="index"
                            >
                             <div class="name">
                              <div  v-if="item.state == 4" class="title-box">
                                已发布
                              </div>
                               <div
                                style="background-color: rgba(179, 183, 190, 1)"
                                v-if="item.state == 5"
                                class="title-box"
                              >
                                已下线
                              </div>
                              <div v-if="item.linkUrl" class="title-box">自定义</div>
                               <div class="link-txt"><span :title="item.title">{{ item.title }}</span></div>
                            </div>
                              &emsp;
                              <span
                                  @click="deleteLinks(index)"
                                  class="icon-close"
                              ></span>
                            </div>
                          </div>
                        </el-form-item>
                        <el-form-item label="关键词" prop="name">
                          <el-input
                              placeholder="多个关键词,以‘,’隔开"
                              v-model="keyword"
                          >
                            <div
                                slot="append"
                                @click="getKeyWords"
                                style="cursor: pointer"
                            >
                              识别关键词
                            </div>
                          </el-input>
                        </el-form-item>
                        <el-form-item label="重定向" prop="redirectUrl">
                          <el-input
                              placeholder="请输入目标url地址"
                              v-model="redirectUrl"
                          >
                          </el-input>
                          <div
                              style="font-size: 12px; margin-top: 0px; color: #909399"
                          >
                            设置重定向地址后，当前稿件正文内容将不再显示，网站页面将跳转至目标地址
                          </div>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="tabs-box">
                <div @click="changeType(1)" class="menhu">
                  <img src="@/assets/images/wangzhan.jpg"/>
                  <div style="min-width:56px">门户网站</div>
                  <div v-if="tabsType == 1" class="tabs-dir"></div>
                </div>
                <div v-if="codeData.indexOf('243') != -1" @click="changeType(2)" class="menhu">
                  <img src="@/assets/images/weixin.png"/>
                  <div>公众号</div>
                  <div v-if="tabsType == 2" class="tabs-dir"></div>
                </div>
                <!-- <div @click="changeType(3)" class="menhu">
                  <img src="@/assets/images/toutiao.png" />
                  <div>头条号</div>
                  <div v-if="tabsType == 3" class="tabs-dir"></div>
                </div> -->
                <div @click="changeType(4)" class="menhu">
                  <img src="@/assets/images/weibo.png"/>
                  <div>微博号</div>
                  <div v-if="tabsType == 4" class="tabs-dir"></div>
                </div>
              </div>
              <el-form
                  v-if="tabsType == 1 && isLodaing"
                  ref="form"
                  style="padding: 0 20px; font-size: 14px;background:#fff"
              >
                <div v-for="(item, index) in ModelColumns" :key="index">
                  <div
                      style="font-weight: bold; font-size: 15px; margin: 26px 0"
                  >
                    {{ item.modelName }}
                  </div>
                  <div
                      v-if="
                      item.fieldResponse.indexRequests &&
                      item.fieldResponse.indexRequests.length > 0
                    "
                  >
                    <el-form-item
                        v-for="(column, columnIndex) in item.fieldResponse
                        .indexRequests"
                        :key="columnIndex"
                    >
                      <!-- <el-input v-model="item.fieldResponse.fieldTextCreateRequests[columnIndex].content" v-if="column.type==0" :placeholder="column.tips"></el-input> -->
                      <div class="item-box-one">
                        <div class="label-box">
                          <span v-if="column.flagRequired == 0" style="color:red">*</span>
                          <span>{{ column.textName }}</span>
                        </div>
                        <div style="width:100%">
                          <a-input
                              v-model="
                                    item.fieldResponse.indexRequests[
                                      columnIndex
                                    ].content
                                  "
                              :placeholder="column.tips"
                              size="large"
                              @change="changeText"
                          />
                          <div
                              class="item-error"
                              v-if="!column.content && column.flagRequired == 0"
                          >
                            必填
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div
                      v-if="
                      item.fieldResponse.fieldTextCreateRequests &&
                      item.fieldResponse.fieldTextCreateRequests.length > 0
                    "
                  >
                    <el-form-item
                        v-for="(column, columnIndex) in item.fieldResponse
                        .fieldTextCreateRequests"
                        :key="columnIndex"
                    >
                      <!-- <el-input v-model="item.fieldResponse.fieldTextCreateRequests[columnIndex].content" v-if="column.type==0" :placeholder="column.tips"></el-input> -->
                      <div class="item-box-one">
                        <div class="label-box">
                          <span v-if="column.flagRequired == 0" style="color:red">*</span>
                          <span>{{ column.textName }}</span>
                        </div>
                        <div style="width:100%">
                          <a-input
                              v-model="
                                    item.fieldResponse.fieldTextCreateRequests[
                                      columnIndex
                                    ].content
                                  "
                              :placeholder="column.tips"
                              v-if="column.type == 0"
                              size="large"
                              @change="changeText"
                          />
                          <!-- <el-input type="textarea" :rows="2" :placeholder="column.tips" v-model="column.content" v-if="column.type==1"> </el-input> -->
                          <a-textarea
                              v-model="column.content"
                              :placeholder="column.tips"
                              allow-clear
                              v-if="column.type == 1"
                              @change="changeText"
                          />
                          <div
                              class="item-error"
                              v-if="!column.content && column.flagRequired == 0"
                          >
                            必填
                          </div>
                          <div
                              class="item-error"
                              v-if="
                                    column.content && column.wordLimit &&
                                    column.content.length > column.wordLimit
                                  "
                          >
                            最多{{ column.wordLimit }}字
                          </div>
                          <div
                              class="item-error"
                              v-if="
                                    column.content && textFn(column)
                                  "
                          >
                            {{ textFn(column) }}
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div
                      v-if="
                      item.fieldResponse.fieldOptionCreateRequests &&
                      item.fieldResponse.fieldOptionCreateRequests.length > 0
                    "
                  >
                    <el-form-item
                        v-for="(column, columnIndex) in item.fieldResponse
                        .fieldOptionCreateRequests"
                        :key="columnIndex"
                    >
                      <div style="width:100%" class="item-box-one">
                        <div class="label-box">
                          <span v-if="column.flagRequired == 0" style="color:red">*</span>
                          <span>{{ column.textName }}</span>
                        </div>
                        <div style="width:100%">
                          <el-radio-group
                              v-model="column.content"
                              v-if="column.type == 0"
                              class="radio-box"
                          >
                            <el-radio
                                :label="option.id"
                                v-for="(option, optionIndex) in column.optionContents"
                                :key="optionIndex"
                            >{{ option.content }}
                            </el-radio
                            >
                          </el-radio-group>
                          <el-checkbox-group
                              v-model="column.content"
                              v-if="column.type == 1"
                          >
                            <el-checkbox
                                v-for="(option, optionIndex) in column.optionContents"
                                :label="option.id"
                                :key="optionIndex"
                            >{{ option.content }}
                            </el-checkbox
                            >
                          </el-checkbox-group>
                          <el-select
                              v-model="column.content"
                              v-if="column.type == 2"
                          >
                            <el-option
                                :label="option.content"
                                :value="option.id"
                                v-for="(option, optionIndex) in column.optionContents"
                                :key="optionIndex"
                            ></el-option>
                          </el-select>
                          <div
                              class="item-error"
                              v-if="!column.content && column.flagRequired == 0 && column.type != 1"
                          >
                            必填
                          </div>
                          <div
                              class="item-error"
                              v-if="(!column.content || (column.content && column.content.length == 0)) && column.flagRequired == 0 && column.type == 1"
                          >
                            必填
                          </div>
                        </div>
                      </div>

                    </el-form-item>
                  </div>
                  <div
                      v-if="
                      item.fieldResponse.dateCreateRequest &&
                      item.fieldResponse.dateCreateRequest.length > 0
                    "
                  >
                    <el-form-item
                        v-for="(column, columnIndex) in item.fieldResponse
                        .dateCreateRequest"
                        :key="columnIndex"
                    >
                      <div class="item-box-one">
                        <div class="label-box">
                          <span v-if="column.flagRequired == 0" style="color:red">*</span>
                          <span>{{ column.textName }}</span>
                        </div>
                        <div style="width:100%">
                          <el-date-picker
                              v-model="column.content"
                              type="date"
                              style="width:100%"
                              placeholder="选择日期"
                              v-if="column.dateType == 0"
                              :picker-options="pickerOptions"
                              @input="changeTime"
                          ></el-date-picker>
                          <el-time-picker
                              v-model="column.content"
                              @input="changeTime"
                              style="width:100%"
                              v-if="column.dateType == 1"
                              :picker-options="{
                          selectableRange:'18:30:00 - 20:30:00'
                         }"
                          >
                          </el-time-picker>
                          <el-date-picker
                              v-model="column.content"
                              @input="changeTime"
                              type="datetime"
                              style="width:100%"
                              v-if="column.dateType == 2"
                          ></el-date-picker>
                          <div
                              class="item-error"
                              v-if="!column.content && column.flagRequired == 0"
                          >
                            必填
                          </div>
                        </div>
                      </div>

                    </el-form-item>
                  </div>
                  <div
                      v-if="
                      item.fieldResponse.fieldFileCreateRequests &&
                      item.fieldResponse.fieldFileCreateRequests.length > 0
                    "
                  >
                    <el-form-item
                        :label="column.textName"
                        v-for="(column, columnIndex) in item.fieldResponse
                        .fieldFileCreateRequests"
                        :key="columnIndex"
                    >
                      <el-upload
                          :show-file-list="false"
                          :before-upload="
                          (file) =>
                            beforeUpload(file, item.id, column.id, column, 0)
                        "
                          action="#"
                          list-type="picture-card"
                          :multiple="false"
                          class="dantu-upload"
                          v-if="column.type == 0"
                      >
                        <img
                            v-if="imgUrlList[column.id+column.type] && imgUrlList[column.id+column.type][0] && imgUrlList[column.id+column.type][0].path"
                            :src="imgIp + imgUrlList[column.id+column.type][0].path"
                            class="el-upload-list__item-thumbnail"
                        />
                        <i class="el-icon-plus" v-else></i>
                        <div class="dantu-yan item-error"
                             v-if="(!imgUrlList[column.id+column.type] || (imgUrlList[column.id+column.type] && imgUrlList[column.id+column.type].length == 0)) && column.flagRequired == 0"
                             style="margin-right:10px">必填
                        </div>
                      </el-upload>
                      <a-upload
                          multiple
                          :file-list="moreImgUrlList[column.id+column.type]"
                          :before-upload="
                          (file,fileList) =>
                            beforeUpload(file, item.id, column.id, column, 1,fileList)
                        "
                          style="margin-left: 20px"
                          :remove="
                          (file) =>
                            removeImg(file, item.id, column.id, column, 1)
                        "
                          v-if="column.type == 1"
                      >
                        <el-button size="small" type="primary"
                        ><img
                            class="add-img"
                            src="@/assets/images/add.jpg"
                        />上传图片
                        </el-button
                        >
                        <div
                            v-if="(!fileListTwo[column.id + column.type] || (fileListTwo[column.id + column.type] && fileListTwo[column.id + column.type].length == 0)) && column.flagRequired == 0"
                            style="margin-right:10px" class="item-error">必填
                        </div>
                      </a-upload>
                      <a-upload
                          :file-list="vidioList[column.id+column.type]"
                          :before-upload="
                          (file) =>
                            beforeUpload(file, item.id, column.id, column, 2)
                        "
                          style="margin-left: 20px"
                          v-if="column.type == 2"
                          :remove="
                          (file) =>
                            removeVideo(file, item.id, column.id, column, 1)
                        "
                      >
                        <el-button size="small" type="primary"
                        ><img
                            class="add-img"
                            src="@/assets/images/add.jpg"
                        />上传视频
                        </el-button
                        >
                        <div
                            v-if="(!fileListTwoVideo[column.id + column.type] || (fileListTwoVideo[column.id + column.type] && fileListTwoVideo[column.id + column.type].length == 0)) && column.flagRequired == 0"
                            style="margin-right:10px" class="item-error">必填
                        </div>
                      </a-upload>
                      <a-upload
                          :file-list="mp3List[column.id+column.type]"
                          :before-upload="
                          (file) =>
                            beforeUpload(file, item.id, column.id, column, 3)
                        "
                          style="margin-left: 20px"
                          v-if="column.type == 3"
                          :remove="
                          (file) =>
                            removeMp3(file, item.id, column.id, column, 1)
                        "
                      >
                        <el-button size="small" type="primary"
                        ><img
                            class="add-img"
                            src="@/assets/images/add.jpg"
                        />上传音频
                        </el-button
                        >
                        <div
                            v-if="(!fileListTwoMp3[column.id + column.type] || (fileListTwoMp3[column.id + column.type] && fileListTwoMp3[column.id + column.type].length == 0)) && column.flagRequired == 0"
                            style="margin-right:10px" class="item-error">必填
                        </div>
                      </a-upload>
                      <a-upload
                          :file-list="fileList[column.id+column.type]"
                          :before-upload="
                          (file) =>
                            beforeUpload(file, item.id, column.id, column, 4)
                        "
                          style="margin-left: 20px"
                          v-if="column.type == 4"
                          :remove="
                          (file) =>
                            removeFile(file, item.id, column.id, column, 1)
                        "
                      >
                        <el-button size="small" type="primary"
                        ><img
                            class="add-img"
                            src="@/assets/images/add.jpg"
                        />上传附件
                        </el-button
                        >
                        <div
                            v-if="(!fileListTwoFile[column.id + column.type] || (fileListTwoFile[column.id + column.type] && fileListTwoFile[column.id + column.type].length == 0)) && column.flagRequired == 0"
                            style="margin-left:10px;margin-top:10px" class="item-error">必填
                        </div>
                      </a-upload>
                    </el-form-item>
                  </div>
                  <div
                      style="
                      height: 2px;
                      width: 90%;
                      background: #f0f2f5;
                      margin: 0 auto;
                    "
                  ></div>
                </div>
              </el-form>
              <div v-if="tabsType == 2 && codeData.indexOf('243') != -1">
                <div style="padding: 20px">
                  <el-button @click="selectWeiXin" type="primary">+选择公众号</el-button>
                  <div v-for="(newItem,index) in newSelectData" class="acc-list">
                    <div>{{ newItem.nickName || newItem.name }}</div>
                    <span @click="weiXinDel(index)" class="icon-close new-close"></span>
                  </div>
                </div>
                <div class="set-title">
                  <div class="line" style="width: 30%"></div>
                  公众号发布设置
                  <div class="line" style="width: 30%"></div>
                </div>
                <div style="max-width: 380px;margin: 20px auto 0;font-size: 14px;line-height: 24px;color: #909399;">
                  （1）说明<br/>
                  1. 通过综合信息平台推送公众号，微信服务号每月可发布4条，微信订阅号每天可发布1条；<br/>
                  2. 审核通过后，需至“我的稿件”或“稿件库”页面，在关联新媒体中点击发布才能发布成功。<br/>
                  <!--                （2）新媒体展示封面选项调整<br/>-->
                  <!--                1. 默认状态下，使用已有封面和单独上传两个选项未选择，且不显示图片上传框；<br/>-->
                  <!--                2. 选择使用已有封面，若当前稿件有封面，则在图片上传框位置显示封面，若当前稿件无封面，则提示“请在稿件发文设置中添加展示封面后再选择”，此时“使用已有封面”选项仍未选中；<br/>-->
                  <!--                3. 选择单独上传时，显示图片上传框；<br/>-->
                  <!--                4. 若单独上传并选择图片后，选择使用已有封面，若稿件有封面则切换选项并显示稿件封面，若无则不切换并按第2点提示，切换后再切换回单独上传，之前上传的图片需保留显示-->
                </div>
                <el-form
                    ref="form"
                    label-width="68px"
                    style="padding: 0 20px; margin: 20px 0;background:#fff"
                >
                  <el-form-item label="展示封面">
                    <el-radio-group v-model="weiForm.imgType" @change="radioChange">
                      <el-radio :label="1">使用已有封面</el-radio>
                      <el-radio :label="2">单独上传</el-radio>
                    </el-radio-group>
                    <a-upload
                        name="avatar"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        :before-upload="beforeUploadNewWei"
                        v-if="weiForm.imgType===2"
                    >
                      <img style="width:100%;height:100%" v-if="weiForm.imgUrl" :src="imgIp + weiForm.imgUrl"
                           alt="avatar"/>
                      <div v-else>
                        <a-icon :type="loading ? 'loading' : 'plus'"/>
                        <div class="ant-upload-text">点击上传图片</div>
                      </div>
                    </a-upload>
                    <div style="font-size: 12px; margin-top: -24px" v-if="weiForm.imgType===2">
                      支持5MB以内的jpg、png图片
                    </div>
                    <img style="width: 102px;height: 102px;border-radius: 4px" :src="imgIp + weiForm.imgUrl" alt="" v-else>
                  </el-form-item>
                  <el-form-item label="独立标题">
                    <el-input v-model="weiForm.title"></el-input>
                    <div
                        style="font-size: 12px; margin-top: 0px"
                        placeholder="选填"
                    >
                      若标题为空,则使用文章标题
                    </div>
                  </el-form-item>
                  <el-form-item label="原文链接">
                    <el-input v-model="weiForm.links"></el-input>
                    <div style="font-size: 12px; margin-top: 0px">
                      请勿添加其他公众号的主页链接
                    </div>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="tabsType == 3">
                <div style="padding: 20px">
                  <el-button type="primary">+选择头条号</el-button>
                  <div class="acc-list">
                    <div>甘孜州人民政府</div>
                    <span class="icon-close"></span>
                  </div>
                </div>
                <div class="set-title">
                  <div class="line" style="width: 30%"></div>
                  头条号发布设置
                  <div class="line" style="width: 30%"></div>
                </div>
                <el-form
                    ref="form"
                    label-width="68px"
                    style="padding: 0 20px; margin: 20px 0"
                >
                  <el-form-item label="展示封面">
                    <el-radio-group>
                      <el-radio label="使用已有封面"></el-radio>
                      <el-radio label="单独上传"></el-radio>
                    </el-radio-group>
                    <a-upload
                        name="avatar"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                        :before-upload="beforeUpload"
                        @change="handleChange"
                    >
                      <img v-if="imageUrl" :src="imageUrl" alt="avatar"/>
                      <div v-else>
                        <a-icon :type="loading ? 'loading' : 'plus'"/>
                        <div class="ant-upload-text">点击上传图片</div>
                      </div>
                    </a-upload>
                    <div style="font-size: 12px; margin-top: -24px">
                      支持5m以内的jpg、png图片
                    </div>
                  </el-form-item>
                  <el-form-item label="独立标题">
                    <el-input></el-input>
                    <div
                        style="font-size: 12px; margin-top: 0px"
                        placeholder="选填"
                    >
                      若标题为空,则使用文章标题
                    </div>
                  </el-form-item>
                  <el-form-item label="原文链接">
                    <el-input></el-input>
                    <div style="font-size: 12px; margin-top: 0px">
                      请勿添加其他公众号的主页链接
                    </div>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="tabsType == 4">
                <div style="padding: 20px">
                  <el-button @click="selectWeiBo" type="primary">+选择微博号</el-button>
                  <div v-for="(newItem,index) in sinaWeiBoData" class="acc-list">
                    <div>{{ newItem.screenName || newItem.name }}</div>
                    <span @click="weiBoDel(index)" class="icon-close new-close"></span>
                  </div>
                </div>
                <div class="set-title">
                  <div class="line" style="width: 30%"></div>
                  微博号发布设置
                  <div class="line" style="width: 30%"></div>
                </div>
                <el-form
                    ref="form"
                    label-width="68px"
                    style="padding: 0 20px; margin: 20px 0;background:#fff"
                >
                  <el-form-item label="展示封面">
                    <el-radio-group v-model="weiBoForm.imgType">
                      <el-radio :label="1">使用已有封面</el-radio>
                      <el-radio :label="2">单独上传</el-radio>
                    </el-radio-group>
                    <a-upload
                        name="avatar"
                        list-type="picture-card"
                        class="avatar-uploader"
                        :show-upload-list="false"
                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                        :before-upload="beforeUploadWeiBo"
                    >
                      <img style="width:100%;height:100%" v-if="weiBoForm.imgUrl" :src="imgIp + weiBoForm.imgUrl"
                           alt="avatar"/>
                      <div v-else>
                        <a-icon :type="loading ? 'loading' : 'plus'"/>
                        <div class="ant-upload-text">点击上传图片</div>
                      </div>
                    </a-upload>
                    <div style="font-size: 12px; margin-top: -24px">
                      支持5m以内的jpg、png图片
                    </div>
                  </el-form-item>
                  <el-form-item label="短微博">
                    <el-input type="textarea" v-model="weiBoForm.title" :rows="2" placeholder="多行输入">
                    </el-input>
                    <div
                        style="font-size: 12px; margin-top: 0px"
                        placeholder="选填"
                    >
                      与文章绑定微博内容
                    </div>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
          <div v-if="btnShow" class="setup-bt">
            <div class="setup-bt-one"></div>
            <div class="setup-bt-btn">
              <div class="doc-set">
          <span>正文字数：{{ htmlContentCount }}</span
          >&emsp;
                <a v-if="!isEdit" @click="editTxt" style="color: #415058"
                >发文设置
                  <a-icon type="down"
                  />
                </a>
                <a v-if="isEdit" @click="editTxtTwo" style="color: #415058"
                >正文编辑
                  <a-icon type="up"
                  />
                </a>
              </div>
              <div class="btn-box" style="display: flex">
                <div class="doc-set">
                  <el-button
                      class="cg-box"
                      :loading="loadingDraft"
                      @click="saveManuscript(1)"
                      v-if="(state == 0 || state == 3) && codeData.indexOf('154') != -1"
                  >保存草稿
                  </el-button
                  >
                </div>
                <el-button
                    type="primary"
                    plain
                    size="small"
                    @click="saveManuscript(6)"
                    v-if="codeData.indexOf('179') != -1"
                ><span class="icon-edit-preview"></span>预览
                </el-button
                >
                 <el-button
                    type="primary"
                    size="small"
                    :loading="updateAdoptShow"
                    @click="saveManuscript(100)"
                    v-if="isModify && codeData.indexOf('370') != -1"
                >修改采纳
                </el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    :loading="loadingExamine"
                    @click="saveManuscript(2)"
                    v-if="(state == 0 || state == 5 || state == 3) && codeData.indexOf('155') != -1"
                >提交审核
                </el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    :loading="loadingAdopt"
                    @click="saveManuscript(3)"
                    v-if="state == 1 && codeData.indexOf('156') != -1"
                >通过
                </el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    :loading="loadingReject"
                    @click="saveManuscript(4)"
                    v-if="state == 1 && codeData.indexOf('157') != -1"
                >驳回
                </el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    :loading="loadingSave"
                    @click="saveManuscript(5)"
                    v-if="(state == 2 || state == 4) && codeData.indexOf('178') != -1"
                >保存
                </el-button
                >
              </div>
            </div>
            <div class="setup-bt-two"></div>
          </div>
        </div>
        <choose-cover
            :resourceIsShow="resourceIsShow"
            @colseChooseCover="colseChooseCover"
            ref="chooseCover"
            @setCoverImg="setCoverImg"
        ></choose-cover>
        <choose-column
            :isColumn="isColumn"
            v-if="isColumn"
            @colseChooseColumn="colseChooseColumn"
            @setColumnIds="setColumnIds"
            ref="chooseColumn"
            :columnIds="columnIds"
            :isEidt="true"
            :columnData="columnData"
            :itemSiteIds="itemSiteIds"
        ></choose-column>
        <choose-link
            :isLink="isLink"
            v-if="isLink"
            @colseChooseLink="colseChooseLink"
            ref="chooseLink"
            @setLinkIds="setLinkIds"
            :LinkIds="LinkIds"
            @openLink="openLink"
        ></choose-link>
        <history-manuscripts
            :historyIsShow="historyIsShow"
            @closeHistory="closeHistory"
            ref="history"
            @toHistory="toHistory"
            :manuscriptId="manuscriptId"
        ></history-manuscripts>
        <missensitivity
            :misseIsShow="misseIsShow"
            @closeMisse="closeMisse"
            :title="title"
            :abstractText="abstractText"
            :content="htmlContent"
            @saveMisse="saveMisse"
            v-if="misseIsShow"
            ref="missensity"
        ></missensitivity>
        <a-modal
            title="选择文件"
            :visible="importIsShow"
            @cancel="closeImport"
            centered
            width="30%"
            heigth="500px"
            class="import"
            @ok="importWord"
        >
          <div>
            <div class="tips">
              <span class="icon-info"></span>&nbsp;导入文件后，现有正文内容将被删除
            </div>
            <div>
              <a-upload-dragger
                  name="file"
                  :multiple="true"
                  :fileList="fileListExple"
                  action="#"
                  :before-upload="beforeUploadFile"
                  :remove="remove"
              >
                <div v-if="importType == 1">
                  <p class="ant-upload-drag-icon">
                    <span class="icon-edit-word"></span>
                  </p>
                  <a-button> 选择文件</a-button>
                  <p class="ant-upload-hint">
                    可直接将文件拖拽到此处进行上传，支持格式：doc、docx
                  </p>
                </div>
                <div v-if="importType == 2">
                  <p class="ant-upload-drag-icon">
                    <span class="icon-edit-excel"></span>
                  </p>
                  <a-button> 选择文件</a-button>
                  <p class="ant-upload-hint">
                    可直接将文件拖拽到此处进行上传，支持格式：xls、xlsx
                  </p>
                </div>
                <div v-if="importType == 3">
                  <p class="ant-upload-drag-icon">
                    <span class="icon-edit-pdf"></span>
                  </p>
                  <a-button> 选择文件</a-button>
                  <p class="ant-upload-hint">
                    可直接将文件拖拽到此处进行上传，支持格式：pdf
                  </p>
                </div>
                <div v-if="importType == 4">
                  <p class="ant-upload-drag-icon">
                    <span class="icon-edit-ppt"></span>
                  </p>
                  <a-button> 选择文件</a-button>
                  <p class="ant-upload-hint">
                    可直接将文件拖拽到此处进行上传，支持格式：ppt、pptx
                  </p>
                </div>
              </a-upload-dragger>
            </div>
          </div>
        </a-modal>
        <dark-link-detection
            :darkLinkShow="darkLinkShow"
            v-if="darkLinkShow"
            @closeMisse="closeDarkLink"
            :editorHtml="editorHtml"
            @removeLink="removeLink"
        ></dark-link-detection>
        <div id="editerHtml" v-show="true" v-html="editorData"></div>
      </div>
    </a-spin>
    <selectWei :newSelectData="newSelectData" @newMedia="newMedia" v-if="isShowWei" :isShowWei="isShowWei"
               @selectCloseWei="selectCloseWei"/>
    <selectWeiBo :newSelectData="sinaWeiBoData" @newMediaWeiBo="newMediaWeiBo" v-if="isShowWeiBo"
                 :isShowWeiBo="isShowWeiBo" @selectCloseWeiBo="selectCloseWeiBo"/>
    <el-dialog
        title="链接导入"
        :visible.sync="linkImportShow"
        width="535px"
        class="column-box"
        :before-close="handleCloseColum"
        top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px;" class="el-icon-info"></i
        >导入文件后，现有正文内容将被删除
      </div>
      <el-form
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          :rules="ruleLink"
          :model="linkTxtForm"
      >
        <el-form-item label="目标链接" prop="linkTxt">
          <el-input
              v-model="linkTxtForm.linkTxt"
              placeholder="请输入目标链接"
          ></el-input>
          <div style="color:#ccc">已支持中国政府网、四川省人民政府网站的文章导入</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="linkImportShow = false">取 消</el-button>
    <el-button :loading="loadingBtn" type="primary" @click="replaceResults">导入</el-button>
  </span>
    </el-dialog>



    <a-modal
        title="选择模板"
        :visible="templateShow"
        @cancel="templateShow = false"
        centered
        width="500px"
        heigth="500px"
        class="template_modal"
    >
      <div>
        <div class="tips">
          <span class="icon-info"></span>&nbsp;使用模板后，现有正文内容将被删除
        </div>
        <div style="display: flex;justify-content: space-between;margin-top: 30px">
          <p>政府信息公开工作年度报告</p>
          <span style="color:#1890FF;cursor: pointer" @click="insertTemp()">使用模板</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
// import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import uEditorWrap from "vue-ueditor-wrap";
import darkLinkDetection from "./darkLinkDetection.vue";
import {
  selectModelByColumnId,
  updateManuscript,
  uploadFile,
  manuscriptDetails,
  createDraft,
  updateFail,
  updateApproved,
  saveManuscript,
  keyWordsExtract,
  importWordToHtml,
  importExcelToHtml,
  importPdfToHtml,
  importPptToHtml,
  previewManuscript,
  importUrlToHtml,
  selectManuscriptDetails,
  updateManuscriptAdopt, getIndexNumber
} from "./manuscripts.js";
import juice from "juice";
import chooseCover from "./chooseCover.vue";
import chooseColumn from "./choose_column.vue";
import chooseLink from "./choose_link.vue";
import historyManuscripts from "./historyManuscripts.vue";
import missensitivity from "./missensitivity.vue";
import {message} from "ant-design-vue";
import {uploadImg, uploadVideo} from "@/utils/common.js";
import {createEditor} from "@wangeditor/editor";
import selectWei from './select_wei.vue';
import selectWeiBo from './select_weiBo.vue';
import {Loading} from "element-ui";
import MonitorKeyboard from '@/utils/monitorKeyboard.js';
import {one} from "./template/index.js";

export default {
  components: {
    // Editor,
    // Toolbar,
    chooseCover,
    chooseColumn,
    chooseLink,
    historyManuscripts,
    missensitivity,
    selectWei,
    darkLinkDetection,
    selectWeiBo,
    uEditorWrap
  },
  data() {
    let self = this;
    return {
      uEditorConfig: {
        // 配置UEditorPlus的惊天资源
        UEDITOR_HOME_URL: process.env.VUE_APP_Admin || '/admin/static/uEditor/',
        UEDITOR_CORS_URL: process.env.VUE_APP_Admin || '/admin/static/uEditor/',
        // 服务器统一请求接口路径
        serverUrl: process.env.VUE_APP_BASE_URL + "/site-service/m/cover/uploadImage"
        // 启用拖放上传
        , enableDragUpload: true
        // 启用粘贴上传
        , enablePasteUpload: true
        // 启用图片拉伸缩放
        , imageScaleEnabled: true
      },
      templateShow: false,
      loadServe:null,
      ueditor:null,
      editor: null,
      loadingBox: false,
      linkImportShow: false,
      darkLinkShow: false,
      editorData: "",
      isShowWeiBo: false,
      width: 0,
      ruleLink: {
        linkTxt: [
          {
            required: true,
            message: "请输入链接",
            trigger: "blur"
          }
        ]
      },
      linkTxtForm: {
        linkTxt: '',
      },
      fileListExple: [],
      loadingBtn: false,
      toolbarConfig: "",
      htmlContent: "",
      monitorKeyboard:'',
      isShowWei: false,
      btnShow:true,
      tabsType: 1,
      editorConfig: {
        hoverbarKeys: {
          attachment: {
            menuKeys: ["downloadAttachment"], // “下载附件”菜单
          },
        },
        MENU_CONF: {
          fontFamily: {
            fontFamilyList: [
              "仿宋_GB2312",
              "黑体",
              "仿宋",
              "楷体",
              "标楷体",
              "华文仿宋",
              "华文楷体",
              "宋体",
              "微软雅黑",
              "Arial",
              "Tahoma",
              "Verdana",
              "Times New Roman",
              "Courier New",
            ],
          },
          uploadAttachment: {
            // server: '', // 服务端地址
            // timeout: 5 * 1000, // 5s
            // meta: {
            //   type: "img",
            // },
            //customInsert: this.customInsert,
            // fieldName: "file",
            // headers: {
            //   token: sessionStorage.getItem("token"),
            // },
            // onBeforeUpload(file) {
            //   return file; // 上传 file 文件
            // },
            // onProgress(progress) {
            //   console.log("onProgress", progress);
            // },
            // onSuccess(file) {
            //   console.log("onSuccess", file, res);
            // },
            // onFailed(file, res) {
            //   alert(res.message);
            //   console.log("onFailed", file, res);
            // },
            // onError(file, err, res) {
            //   alert(err.message);
            //   console.error("onError", file, err, res);
            // },

            // 上传成功后，用户自定义插入文件
            // customInsert(res, file, insertFn) {
            //   console.log('customInsert', res)
            //   const { url } = res.data || {}
            //   if (!url) throw new Error(`url is empty`)

            //   // 插入附件到编辑器
            //   insertFn(`customInsert-${file.name}`, url)
            // },

            // // 用户自定义上传
            customUpload(file, insertFn) {
              let _this = this;
              uploadImg(file, "fujian").then((res) => {
                var encodedData = window.btoa(
                    process.env.VUE_APP_Img_Ip + res.path
                ); // 编码
                let url =
                    `${process.env.VUE_APP_Preview}?url=` + encodedData;
                insertFn(`${file.name}`, url);
              });
            },

            // // 自定义选择
            // customBrowseAndUpload(insertFn: Function) {
            //   alert('自定义选择文件，如弹出图床')
            //   // 自己上传文件
            //   // 上传之后用 insertFn(fileName, link) 插入到编辑器
            // },

            // 插入到编辑器后的回调
            // onInsertedAttachment(elem) {
            //   console.log("inserted attachment", elem);
            // },
          },
          uploadImage: {
            server:
                `${process.env.VUE_APP_BASE_URL}/site-service/m/cover/uploadImage`,
            fieldName: "file",
            maxFileSize: 100 * 1024 * 1024,
            meta: {
              type: "img",
            },
            headers: {
              token: sessionStorage.getItem("token"),
            },
            customInsert: this.customInsert,
          },
          fontSize: {
            fontSizeList: [
              {name: '初号', value: '56px'},
              {name: '小初', value: '48px'},
              {name: '一号', value: '34px'},
              {name: '小一', value: '32px'},
              {name: '二号', value: '29px'},
              {name: '小二', value: '24px'},
              {name: '三号', value: '21px'},
              {name: '小三', value: '20px'},
              {name: '四号', value: '18px'},
              {name: '小四', value: '16px'},
              {name: '五号', value: '14px'},
              {name: '小五', value: '12px'},
            ]
          },
          lineHeight: {
            lineHeightList: ['1', '1.5', '2', '2.5', '3']
          },
          // uploadVideo: {
          //   server:
          //     `${process.env.VUE_APP_BASE_URL}/site-service/m/cover/uploadImage`,
          //   fieldName: "file",
          //   maxFileSize:100* 1024 * 1024 * 1024,
          //   timeout: 60 * 60 * 1000,
          //   meta: {
          //     type: "video",
          //   },
          //   // 上传错误，或者触发 timeout 超时
          //   onError(file, err, res) {  // TS 语法
          //   // onError(file, err, res) {               // JS 语法
          //       console.log(`${file.name} 上传出错`, err, res)
          //   },
          //   // 单个文件上传成功之后
          //   onSuccess(file, res) {  // TS 语法
          //         self.loadingBox = false;
          //         self.loadingBoxTwo = false;
          //       console.log(`${file.name} 上传成功`, res)
          //   },
          //     onProgress(progress) {  // TS 语法
          //         self.loadingBox = true;
          //         self.loadingBoxTwo = true;
          //     },
          //   headers: {
          //     token: sessionStorage.getItem("token"),
          //   },
          //   customInsert: this.customInsert,
          // },
          uploadVideo: {
            maxFileSize: 100 * 1024 * 1024 * 1024,
            timeout: 60 * 60 * 1000,
            customUpload(file, insertFn) {  // TS 语法
              self.loadingBox = true;
              uploadVideo(file, "video").then((res) => {
                if (res.video.path) {
                  self.loadingBox = false;
                  insertFn(self.imgIp + res.video.path, self.imgIp + res.image.path)
                }
              });

            }
          }
        },
      },
      mode: "default", // or 'simple'
      title: "",
      createTime: "",
      source: "",
      abstractText: "",
      modelId: "", //栏目管理的模型id
      keyword: "",
      redirectUrl: "",
      sizeForm: {},
      imageUrl: "",
      loading: false,
      ruleForm: {},
      activeName: "first",
      ModelColumns: [],
      aa: [],
      resourceIsShow: false, //上传图片及资源列表界面
      loadingBoxTwo: false,
      relatedLinks: "",
      isLodaing: false,
      imgUrlList: [], //单图路径
      moreImgUrlList: [], //多图上传路径
      vidioList: [], //视频文件路劲
      mp3List: [], //音频文件路径
      fileList: [], //文件路径
      coverImg: "", //文章封面图
      detailsData: [], //处理过的稿件详情数据
      isColumn: false,
      columnIds: [], //选中的栏目id
      columnData: [], //选中的栏目数据
      manuscriptId: "",
      isLink: false,
      LinkIds: [], //选中的链接id
      LinkInfo: [], //选中的链接数据
      customLinkList: [], //稿件详情查询出来的自定义链接数据
      waitVerify: false, //是否待审稿件编辑
      historyIsShow: false,
      misseIsShow: false,
      state: "", //稿件状态
      htmlContentCount: 0, //字数
      importIsShow: false,
      importFile: {},
      importType: 1, //1 word导入 2 Excel导入 3 PDF导入 4 ppt导入
      isAllman: false,
      txtUpdate: "",
      loadingSave: false,
      loadingReject: false,
      loadingAdopt: false,
      loadingDraft: false,
      loadingExamine: false,
      height: 0,
      fileListTwo: [],
      jsonContent: [
        {
          type: 'paragraph',
          lineHeight: '1.5',
          children: [
            {text: '', fontFamily: '宋体', fontSize: '18px'}
          ]
        },
      ],
      fileListTwoVideo: [],
      fileListTwoMp3: [],
      fileListTwoFile: [],
      newSelectData: [],
      sinaWeiBoData: [],
      itemSiteIds: [],
      weiForm: {
        type: 1,
        title: '',
        links: '',
        imgUrl: '',
        imgType: '',
      },
      weiBoForm: {
        type: 2,
        title: '',
        links: '',
        imgUrl: '',
        imgType: '',
      },
      codeData: [],
      editorHtml: '',
      isEdit: false,
      pickerOptions: {
        // disabledDate(time) {
        // return time.getTime() > Date.now();
        // },
        shortcuts: [{
          text: '2999-12-31',
          onClick(picker) {
            picker.$emit('pick', new Date('2999-12-31'));
          }
        },
        ]
      },
      scoreIds:'',
      isModify:false,
      updateAdoptShow:false,
      noFirst:false,
      emptyUrl:""
    };
  },
  filters: {
    arr(item) {
      return [];
    },
  },
  destroyed() {
    const editor = this.ueditor;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
    if (this.toolbarConfig) {
      this.toolbarConfig = "";
      console.log(this.toolbarConfig, "xxxxxxxxxx");
    }
  },
  watch: {
    //监听正文内容变化以改变总字数
    htmlContent: {
      handler() {
        // this.htmlContentCount = 0;
        // let htmlState = false; //判断i此时是否在标签中
        // let specialState = false; //判断此时i是否在文本输入的< > & 这些特殊字符中
        // for (let i = 0; i < newVal.length; i++) {
        //   if (newVal.charAt(i) === "<") {
        //     htmlState = true;
        //   } else if (newVal.charAt(i) === ">") {
        //     htmlState = false;
        //   } else if (
        //       newVal.charAt(i) != " " &&
        //       !htmlState &&
        //       newVal.charAt(i) != "&" &&
        //       !specialState
        //   ) {
        //     this.htmlContentCount++;
        //   } else if (newVal.charAt(i) === "&") {
        //     specialState = true;
        //   } else if (newVal.charAt(i) === ";" && specialState) {
        //     specialState = false;
        //     this.htmlContentCount++;
        //   }
        // }
        this.htmlContentCount=this.ueditor.getContentLength(true)
      },
    },
  },
  mounted() {
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    this.height = (document.documentElement.clientHeight - 112) + "px";
    window.onresize = () => {
      return (() => {
        this.height = (document.documentElement.clientHeight - 112) + "px";
      })();
    };
    this.manuscriptId = this.$route.query.id;
    if (this.$route.query.isAllman) {
      this.isAllman = this.$route.query.isAllman;
    }
    if (this.$route.query.waitVerify) {
      this.waitVerify = this.$route.query.waitVerify;
    }
    this.isModify = this.$route.query.isModify;
    this.scoreIds = this.$route.query.scoreIds;
    if(this.isModify){
        this.getManuscriptDetailsTwo()
    }else{
         this.getManuscriptDetails();
    }
   
    this.toolbarConfig = {
      excludeKeys: ["todo", "emotion"],
      insertKeys: {
        index: 2, // 自定义插入的位置
        keys: ["uploadAttachment"], // “上传附件”菜单
      },
    };
     this.getKeyboardState()
  },
  computed: {
    textFn(item) {
      return (item) => {
        console.log('ccccccccccccc')
        if (item.inputLimits == 1) {
          var pattern = new RegExp("[\u4E00-\u9FA5]+");
          if (!pattern.test(item.content)) {
            return '只能输入中文'
          }
        }
        if (item.inputLimits == 2) {
          var pattern = new RegExp("[A-Za-z]+");
          if (!pattern.test(item.content)) {
            return '只能输入英文'
          }
        }
        if (item.inputLimits == 3) {
          var pattern = new RegExp("[0-9]+");
          if (!pattern.test(item.content)) {
            return '只能输入数字'
          }
        }
        if (item.inputLimits == 4) {
          var pattern = new RegExp("^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$");
          if (!pattern.test(item.content)) {
            return '输入正确手机号'
          }
        }
        if (item.inputLimits == 5) {
          var pattern = new RegExp("^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+");
          if (!pattern.test(item.content)) {
            return '输入正确邮箱'
          }
        }
        return false;
      }
    }
  },
  methods: {
    openTempModal(){
      this.templateShow = true;
    },
    insertTemp(){
      this.htmlContent = one.code;
      this.templateShow = false;
    },
    radioChange(val){
      if(val===2){
        this.noFirst = true;
        this.weiForm.imgUrl = this.emptyUrl;
      }
      if(!this.coverImg&&val === 1){
        message.error("请在稿件发文设置中添加展示封面后再选择");
        if(this.noFirst) {
          this.weiForm.imgType = 2;
        }else{
          this.weiForm.imgType = ""
        }
        return
      }
      if(val===1){
        this.weiForm.imgUrl = this.coverImg;
      }
    },
     getKeyboardState(){
      let _this = this;
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {  
         _this.btnShow = false;
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
         _this.btnShow = true;
      })
    },
    ueditorReady(editor) {
      this.ueditor = editor;
      this.ueditor.setContent(this.txtUpdate);
      //editor.placeholder('<span style="color:#999">正文</span>')
      this.ueditor.addListener("fullscreenchanged", function(t, enabled) {
        if(!enabled){
          editor.unsetFloating();
        }
      });
    },

    editTxt() {
      this.isEdit = true;
      this.$el.querySelector(`#faWenSet`).scrollIntoView({
        behavior: "smooth",  // 平滑过渡
        block: "start"  // 上边框与视窗顶部平齐。默认值
      });
    },
    editTxtTwo() {
      this.isEdit = false;
      this.$el.querySelector(`#zaiYao`).scrollIntoView({
        behavior: "smooth",  // 平滑过渡
        block: "start"  // 上边框与视窗顶部平齐。默认值
      });
    },
    removeLink(item) {
      this.$nextTick(() => {
        this.ueditor.setContent(item);
        this.darkLinkShow = false;
      })
    },
    newMedia(newSelectData) {
      this.newSelectData = newSelectData;
      console.log(this.newSelectData, 'xxx')
    },
    selectWeiXin() {
      console.log('sssss')
      this.isShowWei = true;
    },
    beforeUploadNewWei(file) {
      // 验证大小
      if (file.size > 5 * 1024 * 1024) {
        message.error('只能上传5MB以内的图片')
        return;
      }
      const isJpgOrPng = file.type === "image/jpg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error('只能上传jpg和png格式图片')
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", 'wei_xin');
      uploadImg(file, 'site_setting').then((res) => {
        this.weiForm.imgUrl = res.path;
        this.emptyUrl = res.path;
      })
      return false;

    },
    selectCloseWei() {
      this.isShowWei = false;
    },
    //word导入
    importWord() {
      const _this = this;
      let formData = new FormData();
      formData.append("file", _this.importFile);
      this.loadServe=Loading.service({fullscreen:true});
      switch (_this.importType) {
        case 1:
          importWordToHtml(formData).then((res) => {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
            if (res.code == 0) {
              // this.editor.select([]);
              // this.editor.deleteFragment();
              let resData = juice(res.data.html);
              this.editorData = resData;
              if (res.data.format == "docx") {
                this.$nextTick(() => {
                  let fter = document
                      .getElementById("editerHtml")
                      .getElementsByTagName("p");
                  for (const item in fter) {
                    let one = fter[item].children;
                    if (one && one.length > 0) {
                      for (const iteratorOne of one) {
                        for (const iterator of iteratorOne.style) {
                          if (iterator == "font-weight") {
                            iteratorOne.innerHTML = `<b>${iteratorOne.textContent}</b>`;
                          }
                        }
                      }
                    }
                  }
                  this.ueditor.setContent(
                      document.getElementById("editerHtml").innerHTML
                  );
                });
              } else {
                this.$nextTick(() => {
                  let fter = document
                      .getElementById("editerHtml")
                      .getElementsByTagName("p");
                  for (const item in fter) {
                    let one = fter[item].children;
                    if (one && one.length > 0) {
                      for (const iterator of one[0].style) {
                        let fontSize = this.getDefaultStyle(
                            one[0].parentNode,
                            "font-size"
                        );
                        let fontFamily = this.getDefaultStyle(
                            one[0].parentNode,
                            "font-family"
                        );
                        one[0].style.fontSize = `${fontSize}`;
                        one[0].style.fontFamily = `${fontFamily}`;
                        if (iterator == "font-weight") {
                          one[0].innerHTML = `<b>${one[0].textContent}</b>`;
                        }
                      }
                    }
                  }
                  this.ueditor.setContent(
                      document.getElementById("editerHtml").innerHTML
                  );
                });
              }
              _this.importIsShow = false;
            }
          }).catch(()=> {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
          });
          break;
        case 2:
          importExcelToHtml(formData).then((res) => {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
            if (res.code == 0) {
              // this.editor.select([]);
              // this.editor.deleteFragment();
              this.ueditor.setContent(juice(res.data.html));
              //_this.htmlContent = juice(res.data)
              // console.log(_this.htmlContent, "dsadsa");
              _this.importIsShow = false;
            }
          }).catch(()=> {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
          });
          break;
        case 3:
          importPdfToHtml(formData).then((res) => {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
            if (res.code == 0) {
              _this.htmlContent = res.data.html;
              _this.importIsShow = false;
            }
          }).catch(()=> {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
          });
          break;
        case 4:
          importPptToHtml(formData).then((res) => {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
            if (res.code == 0) {
              _this.htmlContent = res.data.html;
              _this.importIsShow = false;
            }
          }).catch(()=> {
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              this.loadServe.close();
            });
          });
          break;
      }
    },
    getDefaultStyle(dd, attribute) {
      // 返回最终样式函数，兼容 IE 和 DOM，设置参数：元素对象、样式特性

      return dd.currentStyle
          ? dd.currentStyle[attribute]
          : document.defaultView.getComputedStyle(dd, false)[attribute];
    },
    customInsert(res, insertFn) {
      if (res.code != 0) {
        message.error(res.msg);
        return;
      }
      let url = this.imgIp + res.data.path;
      let alt = res.data.name;
      insertFn(url, alt, "");
    },
    toBack() {
      // if (this.isAllman) {
      //   this.$router.push({
      //     path: "/index/content/all_manuscripts",
      //     query: {
      //       type: this.$route.query.type,
      //     },
      //   });
      // } else {
      //   window.history.go(-1);
      // }
       window.close();
    },
    imgList(data, index, columnIndex, column, type) {
      this.beforeUpload(data.file, index, columnIndex, column, type);
    },
    // onCreated(editor) {
    //   let a = (this.editor = Object.seal(editor)); // 一定要用 Object.seal() ，否则会报错
    //   this.$nextTick(() => {
    //     this.editor.select([]);
    //     this.editor.deleteFragment();
    //     this.editor.dangerouslyInsertHtml(this.txtUpdate);
    //   });
    // },
    identifyKeywords() {
    },
    beforeUpload(file, itemId, columnId, column, type, fileList = []) {
      const _this = this;
      console.log(file, 'sssssss');
      // 文件验证 大小验证
      if (column.fileSize != 0) {
        if (column.dataType == 0) {
          if (file.size > column.fileSize * 1024) {
            message.error("文档大小不能超过" + column.fileSize + "kb");
            return;
          }
        } else {
          if (file.size > column.fileSize * 1024 * 1024) {
            message.error("文档大小不能超过" + column.fileSize + "MB");
            return;
          }
        }
      }
      // 验证 文件格式
      if (type == 1 || type == 0) {
        let indexFile = file.type.lastIndexOf("/");
        let str = file.type.substring(indexFile + 1, file.type.length);
        console.log(column.uploadType.split(','), file, 'ss')
        if (column.uploadType.split(',').indexOf(str) == -1) {
          message.error('只能上传格式为' + column.uploadType + '的文件')
          return;
        }
      } else {
        let indexFile = file.name.lastIndexOf(".");
        let str = file.name.substring(indexFile + 1, file.name.length);
        if (column.uploadType.split(',').indexOf(str) == -1) {
          message.error('只能上传格式为' + column.uploadType + '的文件')
          return;
        }
      }
      // 文件数量
      switch (type) {
        case 1:
          var array = [];
          if (_this.moreImgUrlList[column.id + column.type] && _this.moreImgUrlList[column.id + column.type].length > 0) {
            array = [
              ..._this.moreImgUrlList[column.id + column.type],
              ...fileList,
            ];
          } else {
            array = [...fileList];
          }
          if (array.length > column.number) {
            message.error("最多只能上传" + column.number + "文件");
            return;
          }
          break;
        // case 2:
        //   var array = [];
        //   if (_this.vidioList[column.id + column.type] && _this.vidioList[column.id + column.type].length > 0) {
        //     array = [..._this.vidioList[column.id + column.type], ...fileList];
        //   } else {
        //     array = [...fileList];
        //   }
        //   if (array.length > column.number) {
        //     message.error("最多只能上传" + column.number + "文件");
        //     return;
        //   }
        //   break;
        // case 3:
        //   var array = [];
        //   if (_this.mp3List[column.id + column.type] && _this.mp3List[column.id + column.type].length > 0) {
        //     array = [..._this.mp3List[column.id + column.type], ...fileList];
        //   } else {
        //     array = [...fileList];
        //   }
        //   if (array.length > column.number) {
        //     message.error("最多只能上传" + column.number + "文件");
        //     return;
        //   }
        //   break;
        // case 4:
        //   var array = [];
        //   if (_this.fileList[column.id + column.type] && _this.fileList[column.id + column.type].length > 0) {
        //     array = [..._this.fileList[column.id + column.type], ...fileList];
        //   } else {
        //     array = [...fileList];
        //   }
        //   if (array.length > column.number) {
        //     message.error("最多只能上传" + column.number + "文件");
        //     return;
        //   }
        //   break;
      }
      let formData = new FormData();
      formData.append("type", type);
      formData.append("uploadType", column.uploadType);
      formData.append("fileSize", column.fileSize);
      formData.append("dataType", column.dataType);
      formData.append("number", column.dataType);
      formData.append("files", file);
      uploadFile(formData).then((res) => {
        if (res.code == 0) {
          if (res.data.error.length > 0) {
            message.error(res.data.error[0].msg);
            return;
          }
          var encodedData = window.btoa(
              process.env.VUE_APP_Img_Ip + res.data.correct[0].path
          ); // 编码
          let url =
              `${process.env.VUE_APP_Preview}?url=` + encodedData;
          file.url = url;
          switch (type) {
            case 0:
              _this.imgUrlList[column.id + column.type] = [res.data.correct[0]];
              _this.imgUrlList = JSON.parse(JSON.stringify(_this.imgUrlList));
              break;
            case 1:
              if (!_this.fileListTwo[column.id + column.type]) {
                _this.fileListTwo[column.id + column.type] = [];
              }
              if (!_this.moreImgUrlList[column.id + column.type]) {
                _this.moreImgUrlList[column.id + column.type] = []
              }
              _this.fileListTwo[column.id + column.type].push(res.data.correct[0])
              _this.moreImgUrlList[column.id + column.type].push(file)
              //_this.moreImgUrlList[index][columnIndex + "url"].push(res.data.correct[0].path)
              _this.fileListTwo = JSON.parse(
                  JSON.stringify(_this.fileListTwo)
              );
              break;
            case 2:
              if (!_this.fileListTwoVideo[column.id + column.type]) {
                _this.fileListTwoVideo[column.id + column.type] = [];
              }
              if (!_this.vidioList[column.id + column.type]) {
                _this.vidioList[column.id + column.type] = [];
              }
              _this.fileListTwoVideo[column.id + column.type].push(res.data.correct[0])
              _this.vidioList[column.id + column.type].push(file)
              _this.fileListTwoVideo = JSON.parse(JSON.stringify(_this.fileListTwoVideo));
              break;
            case 3:
              if (!_this.fileListTwoMp3[column.id + column.type]) {
                _this.fileListTwoMp3[column.id + column.type] = [];
              }
              if (!_this.mp3List[column.id + column.type]) {
                _this.mp3List[column.id + column.type] = [];
              }
              _this.fileListTwoMp3[column.id + column.type].push(res.data.correct[0])
              _this.mp3List[column.id + column.type].push(file)
              _this.fileListTwoMp3 = JSON.parse(JSON.stringify(_this.fileListTwoMp3));
              break;
            case 4:
              if (!_this.fileListTwoFile[column.id + column.type]) {
                _this.fileListTwoFile[column.id + column.type] = [];
              }
              if (!_this.fileList[column.id + column.type]) {
                _this.fileList[column.id + column.type] = [];
              }
              _this.fileListTwoFile[column.id + column.type].push(res.data.correct[0])
              _this.fileList[column.id + column.type].push(file)
              _this.fileListTwoFile = JSON.parse(JSON.stringify(_this.fileListTwoFile));
              break;
          }
        }
      });
      //console.log(res,'shang')
      return false;
    },
    handleChange() {
    },
    handleClick() {
    },
    getModelByColumnTwo(columnIds, arr) {
      const _this = this;
      selectModelByColumnId({idList: columnIds}).then((res) => {
        if (res.code == 0) {
          // _this.ModelColumns = res.data;
          let modelColumns = res.data;
          let modelId = [];
          // _this.ModelColumns.forEach((item) => {
          for (let i = 0; i < modelColumns.length; i++) {
            if (
                modelColumns[i].fieldResponse.dateCreateRequest &&
                modelColumns[i].fieldResponse.dateCreateRequest.length
            ) {
              modelColumns[i].fieldResponse.dateCreateRequest.map((column) => {
                if (column.defaultDate) {
                  column.content = "";
                } else {
                  column.content = new Date();
                }
                if (arr && arr.length > 0 && arr[`${column.id}${column.type}`]) {
                  column.content = arr[`${column.id}${column.type}`] && arr[`${column.id}${column.type}`].content;
                }
                column.fieldId = column.id;
              });
            }

            if (
                modelColumns[i].fieldResponse.indexRequests &&
                modelColumns[i].fieldResponse.indexRequests.length
            ) {
              modelColumns[i].fieldResponse.indexRequests.map((column) => {
                // column.content=""
                if (arr && arr.length > 0 && arr[`${column.id}${column.type}`]) {
                  column.content = arr[`${column.id}${column.type}`] && arr[`${column.id}${column.type}`].content;
                }
                column.fieldId = column.id;
              });
            }


            if (
                modelColumns[i].fieldResponse.fieldTextCreateRequests &&
                modelColumns[i].fieldResponse.fieldTextCreateRequests.length
            ) {
              modelColumns[i].fieldResponse.fieldTextCreateRequests.map((column) => {
                // column.content=""
                if (arr && arr.length > 0 && arr[`${column.id}${column.type}`]) {
                  column.content = arr[`${column.id}${column.type}`] && arr[`${column.id}${column.type}`].content;
                }
                column.fieldId = column.id;
              });
            }
            if (
                modelColumns[i].fieldResponse.fieldOptionCreateRequests &&
                modelColumns[i].fieldResponse.fieldOptionCreateRequests.length
            ) {
              modelColumns[i].fieldResponse.fieldOptionCreateRequests.map((column) => {
                column.fieldId = column.id;
                if (column.type == 0) {
                  column.content = "";
                } else if (column.type == 1) {
                  column.content = [];
                } else if (column.type == 2) {
                  column.content = "";
                }
                if (arr && arr.length > 0 && arr[`${column.id}${column.type}`]) {
                  column.content = arr[`${column.id}${column.type}`] && arr[`${column.id}${column.type}`].content;
                }
              });

            }
            // 文件上传
            if (
                modelColumns[i].fieldResponse.fieldFileCreateRequests &&
                modelColumns[i].fieldResponse.fieldFileCreateRequests.length
            ) {
              modelColumns[i].fieldResponse.fieldFileCreateRequests.map((column) => {
                if (column.type == 0) {
                  if (!this.imgUrlList[column.id + column.type]) {
                    this.imgUrlList[column.id + column.type] = [];
                  }
                }
                if (column.type == 1) {
                  if (!this.fileListTwo[column.id + column.type]) {
                    this.fileListTwo[column.id + column.type] = [];
                  }
                  if (!this.moreImgUrlList[column.id + column.type]) {
                    this.moreImgUrlList[column.id + column.type] = [];
                  }

                }
                if (column.type == 2) {
                  if (!this.fileListTwoVideo[column.id + column.type]) {
                    this.fileListTwoVideo[column.id + column.type] = [];
                  }

                  if (!this.vidioList[column.id + column.type]) {
                    this.vidioList[column.id + column.type] = [];
                  }

                }
                if (column.type == 3) {
                  if (!this.fileListTwoMp3[column.id + column.type]) {
                    this.fileListTwoMp3[column.id + column.type] = [];
                  }
                  if (!this.mp3List[column.id + column.type]) {
                    this.mp3List[column.id + column.type] = [];
                  }
                }
                if (column.type == 4) {
                  if (!this.fileListTwoFile[column.id + column.type]) {
                    this.fileListTwoFile[column.id + column.type] = [];
                  }
                  if (!this.fileList[column.id + column.type]) {
                    this.fileList[column.id + column.type] = [];
                  }
                }
              });
            }
            if (modelColumns[i].fieldResponse.indexRequests && modelColumns[i].fieldResponse.indexRequests.length > 0) {
              modelColumns[i].fieldResponse.indexRequests.map((column) => {
                if (arr && arr.length > 0 && arr[`${column.id}${column.type}`]) {
                  column.content = arr[`${column.id}${column.type}`].content || '';
                } else {
                  column.content = ''
                }
                if (!column.content) {
                  getIndexNumber({
                    id: sessionStorage.getItem('siteId'),
                  }).then((res) => {
                    if (res.code == 0) {
                      column.content = `${res.data.indexNumber}`;
                    }
                  })
                }
                column.fieldId = column.id;
              })
            }
            modelId.push(modelColumns[i].id);
          };
          _this.ModelColumns = modelColumns;
          _this.modelId = modelId.toString();
          _this.isLodaing = true;
        }
      });
    },
    changeText() {
      this.ModelColumns = JSON.parse(JSON.stringify(this.ModelColumns))
    },
    weiXinDel(index) {
      this.newSelectData.splice(index, 1)
    },
    // newMediaWeiBo(newSelectData){
    //    this.sinaWeiBoData = newSelectData;
    // },
    //根据栏目id查询模型参数
    getModelByColumn(arr) {
      const _this = this;
      if (_this.columnIds.length <= 0) {
        _this.isLodaing = true;
        _this.loadingBox = false;
        return;
      }
      selectModelByColumnId({idList: _this.columnIds}).then((res) => {
        if (res.code == 0) {
          _this.ModelColumns = res.data;
          let modelId = [];
          _this.ModelColumns.forEach((item) => {
            if (
                item.fieldResponse.indexRequests &&
                item.fieldResponse.indexRequests.length
            ) {
              item.fieldResponse.indexRequests.map((column) => {
                if (arr && arr.length > 0 && arr[`${item.id}11${column.id}`]) {
                  // column = arr[`${item.id}${column.id}`].timeDetails
                  column.content = arr[`${item.id}11${column.id}`].content;
                } else {
                  column.content = "";
                }
              });
            }
            if (
                item.fieldResponse.dateCreateRequest &&
                item.fieldResponse.dateCreateRequest.length
            ) {
              item.fieldResponse.dateCreateRequest.map((column) => {
                if (arr && arr.length > 0 && arr[`${item.id}2${column.id}`]) {
                  // column = arr[`${item.id}${column.id}`].timeDetails
                  column.content = arr[`${item.id}2${column.id}`].content;
                } else {
                  column.content = "";
                }
                console.log(column, 66);
              });
            }
            if (
                item.fieldResponse.fieldTextCreateRequests &&
                item.fieldResponse.fieldTextCreateRequests.length
            ) {
              item.fieldResponse.fieldTextCreateRequests.map((column) => {
                if (
                    arr &&
                    arr.length > 0 &&
                    arr[`${item.id}${column.type}${column.id}`]
                ) {
                  // column = arr[`${item.id}${column.id}`].multilineDetails
                  column.content =
                      arr[`${item.id}${column.type}${column.id}`].content;
                  //  column.content=""
                } else {
                  column.content = "";
                }
              });
            }
            if (
                item.fieldResponse.fieldOptionCreateRequests &&
                item.fieldResponse.fieldOptionCreateRequests.length
            ) {
              item.fieldResponse.fieldOptionCreateRequests.map((column) => {
                if (arr && arr.length > 0) {
                  // column = arr[`${item.id}${column.id}`].dropDownDetails
                  //column.content = arr[`${item.id}${column.id}`].content;
                  if (column.type == 0) {
                    column.content =
                        arr[`${item.id}3${column.id}`] &&
                        Number(arr[`${item.id}3${column.id}`].content) || '';
                    console.log(column.content, "--------------");
                  } else if (column.type == 1) {
                    column.content = [];
                    let arrselect =
                        arr[`${item.id}4${column.id}`] &&
                        arr[`${item.id}4${column.id}`].content
                            ? arr[`${item.id}4${column.id}`] &&
                            arr[`${item.id}4${column.id}`].content.split(",")
                            : [];
                    arrselect.map((item) => {
                      column.content.push(Number(item));
                    });
                  } else if (column.type == 2) {
                    column.content =
                        arr[`${item.id}5${column.id}`] &&
                        Number(arr[`${item.id}5${column.id}`].content) || '';
                  }
                } else {
                  if (column.type == 0) {
                    column.content = "";
                  } else if (column.type == 1) {
                    column.content = [];
                  } else if (column.type == 2) {
                    column.content = "";
                  }
                }
              });
            }
            if (
                item.fieldResponse.fieldFileCreateRequests &&
                item.fieldResponse.fieldFileCreateRequests.length > 0
            ) {
              item.fieldResponse.fieldFileCreateRequests.map(
                  (column, columnIndex) => {
                    column.fieldId = column.id;
                    column.modelId = item.id;
                    if (arr && arr.length > 0) {
                      switch (column.type) {
                        case 0:
                          _this.imgUrlList[item.id] = {};
                          _this.imgUrlList[column.id + column.type] = arr[`${item.id}6${column.id}`] && arr[`${item.id}6${column.id}`].content && JSON.parse(arr[`${item.id}6${column.id}`].content) || '';
                          break;
                        case 1:
                          _this.moreImgUrlList[column.id + column.type] = arr[`${item.id}7${column.id}`] && arr[`${item.id}7${column.id}`].content && JSON.parse(arr[`${item.id}7${column.id}`].content) || [];

                          if (_this.moreImgUrlList[column.id + column.type] && _this.moreImgUrlList[column.id + column.type].length > 0) {
                            _this.moreImgUrlList[column.id + column.type] = this.setFileUrl(_this.moreImgUrlList[column.id + column.type])
                          }
                          _this.fileListTwo[column.id + column.type] = arr[`${item.id}7${column.id}`] && arr[`${item.id}7${column.id}`].content && JSON.parse(arr[`${item.id}7${column.id}`].content) || [];
                          break;
                        case 2:

                          _this.vidioList[column.id + column.type] = arr[`${item.id}8${column.id}`] && arr[`${item.id}8${column.id}`].content && JSON.parse(arr[`${item.id}8${column.id}`].content) || [];

                          if (_this.vidioList[column.id + column.type] && _this.vidioList[column.id + column.type].length > 0) {
                            _this.vidioList[column.id + column.type] = this.setFileUrl(_this.vidioList[column.id + column.type])
                          }
                          _this.fileListTwoVideo[column.id + column.type] = arr[`${item.id}8${column.id}`] && arr[`${item.id}8${column.id}`].content && JSON.parse(arr[`${item.id}8${column.id}`].content) || [];


                          // _this.vidioList[item.id] = {};
                          // _this.vidioList[item.id][column.id + "url"] =
                          //   arr[`${item.id}8${column.id}`] &&
                          //   arr[`${item.id}8${column.id}`].content;
                          // _this.vidioList = JSON.parse(
                          //   JSON.stringify(_this.vidioList)
                          // );
                          break;
                        case 3:

                          _this.mp3List[column.id + column.type] = arr[`${item.id}9${column.id}`] && arr[`${item.id}9${column.id}`].content && JSON.parse(arr[`${item.id}9${column.id}`].content) || [];
                          if (_this.mp3List[column.id + column.type] && _this.mp3List[column.id + column.type].length > 0) {
                            _this.mp3List[column.id + column.type] = this.setFileUrl(_this.mp3List[column.id + column.type])
                          }
                          _this.fileListTwoMp3[column.id + column.type] = arr[`${item.id}9${column.id}`] && arr[`${item.id}9${column.id}`].content && JSON.parse(arr[`${item.id}9${column.id}`].content) || [];


                          // _this.mp3List[item.id] = {};
                          // _this.mp3List[item.id][column.id + "url"] =
                          //   arr[`${item.id}9${column.id}`] &&
                          //   arr[`${item.id}9${column.id}`].content;
                          // _this.mp3List = JSON.parse(
                          //   JSON.stringify(_this.mp3List)
                          // );
                          break;
                        case 4:
                          _this.fileList[column.id + column.type] = arr[`${item.id}10${column.id}`] && arr[`${item.id}10${column.id}`].content && JSON.parse(arr[`${item.id}10${column.id}`].content) || [];
                          if (_this.fileList[column.id + column.type] && _this.fileList[column.id + column.type].length > 0) {
                            _this.fileList[column.id + column.type] = this.setFileUrl(_this.fileList[column.id + column.type])
                          }
                          _this.fileListTwoFile[column.id + column.type] = arr[`${item.id}10${column.id}`] && arr[`${item.id}10${column.id}`].content && JSON.parse(arr[`${item.id}10${column.id}`].content) || [];

                          // _this.fileList[item.id] = {};
                          // _this.fileList[item.id][column.id + "url"] =
                          //   arr[`${item.id}10${column.id}`] &&
                          //   arr[`${item.id}10${column.id}`].content;
                          // _this.fileList = JSON.parse(
                          //   JSON.stringify(_this.fileList)
                          // );
                          break;
                      }
                    }
                  }
              );
            }
            modelId.push(item.id);
          });
          _this.modelId = modelId.toString();
          _this.loadingBox = false;
          _this.isLodaing = true;
        }
      });
    },
    replaceResults() {
      importUrlToHtml({
        url: this.linkTxtForm.linkTxt,
        proportion: 0.5,
      }).then((res) => {
        if (res.code == 0) {
          this.editorData = res.data.html;
          if (this.ueditor) {
            this.$nextTick(() => {
              // this.editor.select([]);
              // this.editor.deleteFragment();
              console.log(document.getElementById("editerHtml"), 'xxxxxxxxxx');
              this.ueditor.setContent(document.getElementById("editerHtml").innerHTML);
              this.linkImportShow = false;
            });
          }
        }
      })
    },
    openChooseCover() {
      this.resourceIsShow = true;
    },
    handleCloseColum() {
      this.linkImportShow = false;
    },
    linkImport() {
      this.linkImportShow = true;
    },
    changeType(type) {
      this.tabsType = type;
    },
    colseChooseCover() {
      this.resourceIsShow = false;
    },
    openChooseColumn() {
      this.isColumn = true;
      this.$nextTick(() => {
        this.$refs.chooseColumn.getColumnTree();
      });
    },
    //打开暗链检测页面
    openDarkLink() {
      this.editorHtml = this.ueditor.getContent();
      this.darkLinkShow = true;
    },
    closeDarkLink() {
      this.darkLinkShow = false;
    },
    colseChooseLink() {
      this.isLink = false;
    },
    openLink() {
      this.isLink = true;
    },
    openChooseLink() {
      this.isLink = true;
      this.$nextTick(() => {
        this.$refs.chooseLink.getColumnTree();
        //this.$refs.chooseLink.getLinksPage();
        
        this.$refs.chooseLink.setLinkInfoList({
          customLinkList: this.customLinkList,
          LinkInfo: this.LinkInfo,
        });
      });

    },
    setLinkIds(data) {
      this.LinkIds = data.LinkIds;
      this.LinkInfo = data.LinkInfo;
      this.customLinkList = data.customLinkList;
      this.isLink = false;
    },
    addColumn() {
      this.getModelByColumn();
    },
    beforeUploadWeiBo(file) {
      // 验证大小
      if (file.size > 5 * 1024 * 1024) {
        message.error('只能上传5MB以内的图片')
        return;
      }
      const isJpgOrPng = file.type === "image/jpg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error('只能上传jpg和png格式图片')
        return;
      }
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", 'wei_xin');
      uploadImg(file, 'site_setting').then((res) => {
        this.weiBoForm.imgUrl = res.path;
      })
      return false;

    },
    openImport(type) {
      this.importType = type;
      this.fileListExple = [];
      this.importIsShow = true;
    },
    remove() {
      this.fileListExple = [];
    },
    newMediaWeiBo(newSelectData) {
      this.sinaWeiBoData = newSelectData;
    },
    //稿件数据保存
    saveManuscript(cType) {
      if(!this.source){
        message.error("请填写文章来源");
        return;
      }
      if(!this.keyword){
        message.error("请填写关键词或识别关键词");
        return;
      }
      this.ueditor.focus(true)
      setTimeout(()=>{
      const _this = this;
      console.log(this.htmlContent, 'ssssss')
      let errorData = document.getElementsByClassName("item-error");
      if (errorData.length > 0) {
        message.error("请正确填写数据");
        return;
      }
      let siteId = sessionStorage.getItem("siteId");
      let TextRequests = [];
      let takeModelColumns = JSON.parse(JSON.stringify(_this.ModelColumns));
      takeModelColumns.forEach((item) => {
        if (
            item.fieldResponse.fieldFileCreateRequests &&
            item.fieldResponse.fieldFileCreateRequests.length
        ) {
          item.fieldResponse.fieldFileCreateRequests.map((column) => {
            switch (column.type) {
              case 0:
                column.content = _this.imgUrlList[column.id + column.type] ? JSON.stringify(_this.imgUrlList[column.id + column.type]) : '';
                column.type = 6;
                break;
              case 1:
                column.content = _this.fileListTwo[column.id + column.type] && _this.fileListTwo[column.id + column.type].length > 0 ? JSON.stringify(_this.fileListTwo[column.id + column.type]) : '';
                column.type = 7;
                break;
              case 2:
                column.content = _this.fileListTwoVideo[column.id + column.type] && _this.fileListTwoVideo[column.id + column.type].length > 0 ? JSON.stringify(_this.fileListTwoVideo[column.id + column.type]) : '';
                column.type = 8;
                break;
              case 3:
                column.content = _this.fileListTwoMp3[column.id + column.type] && _this.fileListTwoMp3[column.id + column.type].length > 0 ? JSON.stringify(_this.fileListTwoMp3[column.id + column.type]) : '';
                column.type = 9;
                break;
              case 4:
                column.content = _this.fileListTwoFile[column.id + column.type] && _this.fileListTwoFile[column.id + column.type].length > 0 ? JSON.stringify(_this.fileListTwoFile[column.id + column.type]) : '';
                column.type = 10;
                break;
            }
            column.fieldId = column.id;
            column.modelId = item.id;
            column.manuscriptId = _this.manuscriptId;
            if (
                _this.detailsData.length > 0 &&
                _this.detailsData[`${item.id}${column.type}${column.id}`]
            ) {
              column.id =
                  _this.detailsData[`${item.id}${column.type}${column.id}`].id;
            } else {
              column.id = null;
            }
          });
        }
        if (
            item.fieldResponse.dateCreateRequest &&
            item.fieldResponse.dateCreateRequest.length
        ) {
          item.fieldResponse.dateCreateRequest.map((column) => {
            column.type = 2;
            column.fieldId = column.id;
            column.modelId = item.id;
            column.manuscriptId = _this.manuscriptId;
            ;
            column.content = _this.farmatDate(column.content, "-");
            if (
                _this.detailsData.length > 0 &&
                _this.detailsData[`${item.id}${column.type}${column.id}`]
            ) {
              column.id =
                  _this.detailsData[`${item.id}${column.type}${column.id}`].id;
            } else {
              column.id = null;
            }
          });
        }
        if (
            item.fieldResponse.fieldTextCreateRequests &&
            item.fieldResponse.fieldTextCreateRequests.length
        ) {
          item.fieldResponse.fieldTextCreateRequests.map((column) => {
            column.modelId = item.id;
            column.fieldId = column.id;
            column.type = column.type == 0 ? 0 : 1;
            column.manuscriptId = _this.manuscriptId;
            ;
            if (
                _this.detailsData.length > 0 &&
                _this.detailsData[`${item.id}${column.type}${column.id}`]
            ) {
              column.id =
                  _this.detailsData[`${item.id}${column.type}${column.id}`].id;
            } else {
              column.id = null;
            }
          });
        }
        if (
            item.fieldResponse.fieldOptionCreateRequests &&
            item.fieldResponse.fieldOptionCreateRequests.length
        ) {
          item.fieldResponse.fieldOptionCreateRequests.map((column) => {
            column.modelId = item.id;
            column.fieldId = column.id;
            column.type == 1
                ? (column.content = column.content.join(","))
                : (column.content = column.content);
            column.type = column.type == 0 ? 3 : column.type == 1 ? 4 : 5;
            column.manuscriptId = _this.manuscriptId;
            ;
            if (
                _this.detailsData.length > 0 &&
                _this.detailsData[`${item.id}${column.type}${column.id}`]
            ) {
              column.id =
                  _this.detailsData[`${item.id}${column.type}${column.id}`].id;
            } else {
              column.id = null;
            }
          });
        }

        // 索引号
        if (
            item.fieldResponse.indexRequests &&
            item.fieldResponse.indexRequests.length
        ) {
          item.fieldResponse.indexRequests.map((column) => {
            column.type = 11;
            column.fieldId = column.id;
            column.modelId = item.id;
            column.manuscriptId = _this.manuscriptId;
            ;
            if (
                _this.detailsData.length > 0 &&
                _this.detailsData[`${item.id}${column.type}${column.id}`]
            ) {
              column.id =
                  _this.detailsData[`${item.id}${column.type}${column.id}`].id;
            } else {
              column.id = null;
            }
          });
        }

        item.fieldResponse.fieldFileCreateRequests
            ? TextRequests.push(...item.fieldResponse.fieldFileCreateRequests)
            : "";
        item.fieldResponse.fieldOptionCreateRequests
            ? TextRequests.push(...item.fieldResponse.fieldOptionCreateRequests)
            : "";
        item.fieldResponse.fieldTextCreateRequests
            ? TextRequests.push(...item.fieldResponse.fieldTextCreateRequests)
            : "";
        item.fieldResponse.dateCreateRequest
            ? TextRequests.push(...item.fieldResponse.dateCreateRequest)
            : "";
        item.fieldResponse.indexRequests
            ? TextRequests.push(...item.fieldResponse.indexRequests)
            : "";
      });
      _this.LinkInfo && _this.LinkInfo.map((item) => {
        if (!item.type && item.type !== 0) {
          item.maId = item.id;
          item.type = 0;
        }
        item.id = null;
        item.manuscriptId = _this.manuscriptId;
      });
      let mediaConfigRequest = []
      let weiMediaData = [];
      let weiBoMedaData = [];
      let weiData = {...this.weiForm, mediaData: ''};
      let weiBo = {...this.weiBoForm, mediaData: ''}
      if (this.newSelectData.length > 0) {
        for (let index = 0; index < this.newSelectData.length; index++) {
          weiMediaData.push({
            id: this.newSelectData[index].id,
            name: this.newSelectData[index].nickName || this.newSelectData[index].name,
            type: 1,
          })
        }
        weiData.mediaData = JSON.stringify(weiMediaData)
      }
      if (this.sinaWeiBoData.length > 0) {
        for (let index = 0; index < this.sinaWeiBoData.length; index++) {
          weiBoMedaData.push({
            id: this.sinaWeiBoData[index].id,
            name: this.sinaWeiBoData[index].screenName || this.sinaWeiBoData[index].name,
            type: 2,
          })
        }
        weiBo.mediaData = JSON.stringify(weiBoMedaData)
      }
      mediaConfigRequest.push(weiData)
      mediaConfigRequest.push(weiBo)
      let reqData = {
        id: _this.manuscriptId,
        title: _this.title,
        siteId: siteId,
        time: _this.farmatDate(_this.createTime, "-"),
        source: _this.source,
        abstractText: _this.abstractText,
        content: _this.htmlContent,
        columnId: _this.columnIds.join(","),
        modelId: _this.modelId,
        coverImg: _this.coverImg,
        linksRequests: _this.LinkInfo,
        keyword: _this.keyword,
        redirectUrl: _this.redirectUrl,
        detailsTextRequests: TextRequests,
        mediaConfigRequest,
      };
      if (cType == 1) {
        //草稿
        this.loadingDraft = true;
        createDraft(reqData).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            // this.$router.push({
            //   path: "/index/content/all_manuscripts",
            //   query: {type: 2},
            // });
             setTimeout(() => {
                this.toBack();
            }, 2000);
          }
          this.loadingDraft = false;
        });
      } else if (cType == 2) {
        //提交审核
        this.loadingExamine = true;
        updateManuscript(reqData).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            // this.$router.push({
            //   path: "/index/content/all_manuscripts",
            //   query: {type: 2},
            // });
             setTimeout(() => {
                this.toBack();
            }, 2000);
          }
          this.loadingExamine = false;
        });
      } else if (cType == 3) {
        //通过
        this.loadingAdopt = true;
        updateApproved(reqData).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            // this.$router.push({
            //   path: "/index/content/all_manuscripts",
            //   query: {type: 2},
            // });
             setTimeout(() => {
                this.toBack();
            }, 2000);
          }
          this.loadingAdopt = false;
        });
      } else if (cType == 4) {
        //驳回
        this.loadingReject = true;
        updateFail(reqData).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            // this.$router.push({
            //   path: "/index/content/all_manuscripts",
            //   query: {type: 2},
            // });
             setTimeout(() => {
                this.toBack();
            }, 2000);
            this.loadingReject = false;
          } else {
            this.loadingReject = false;
          }
        });
      } else if (cType == 5) {
        //修改保存
        this.loadingSave = true;
        saveManuscript(reqData).then((res) => {
          if (res.code == 0) {
            message.success(res.msg);
            // this.$router.push({
            //   path: "/index/content/all_manuscripts",
            //   query: { type: 2 },
            // });
            setTimeout(() => {
                this.toBack();
            }, 2000);
            
          }
          this.loadingSave = false;
        });
      } else if (cType == 6) {
        if (!reqData.columnId) {
          message.error('请选择栏目');
          this.loading = false;
          this.loadingTwo = false;
          this.loadingThree = false;
          return;
        }
        previewManuscript(reqData).then((res) => {
          window.open('http://' + res.data.previewUrl);
        });
      }else if(cType == 100){
          if (!reqData.columnId) {
            message.error('请选择栏目');
            return;
          }
          this.updateAdoptShow = true;
          updateManuscriptAdopt({
            ...reqData,
            id:this.manuscriptId,
            scoringCriteria: this.scoreIds,
          }).then((res)=>{
              if (res.code == 0) {
                message.success(res.msg);
                setTimeout(() => {
                    this.toBack();
                }, 2000);
              }
              this.updateAdoptShow = false;
          })
      }
    },200);
    },
    removeImg(file, itemId, columnId, column, type) {
      const index = this.moreImgUrlList[column.id + column.type].indexOf(file);
      this.moreImgUrlList[column.id + column.type].splice(index, 1);
      this.fileListTwo[column.id + column.type].splice(index, 1);
    },
    removeVideo(file, itemId, columnId, column, type) {
      const index = this.vidioList[column.id + column.type].indexOf(file);
      this.vidioList[column.id + column.type].splice(index, 1);
      this.fileListTwoVideo[column.id + column.type].splice(index, 1);
    },
    removeMp3(file, itemId, columnId, column, type) {
      const index = this.mp3List[column.id + column.type].indexOf(file);
      this.mp3List[column.id + column.type].splice(index, 1);
      this.fileListTwoMp3[column.id + column.type].splice(index, 1);
    },
    removeFile(file, itemId, columnId, column, type) {
      const index = this.fileList[column.id + column.type].indexOf(file);
      this.fileList[column.id + column.type].splice(index, 1);
      this.fileListTwoFile[column.id + column.type].splice(index, 1);
    },
    changeTime(data) {
      this.ModelColumns = JSON.parse(JSON.stringify(this.ModelColumns));
    },
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
          (date.getMonth() + 1 < 10
              ? "0" + (date.getMonth() + 1)
              : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
          (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
          ":";
      var ss =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + " " + hh + mm + ss;
    },
    setCoverImg(imageUrl) {
      this.coverImg = imageUrl;
    },
    selectWeiBo() {
      this.isShowWeiBo = true;
    },
    selectCloseWeiBo() {
      this.isShowWeiBo = false;
    },
    //稿件详情
    getManuscriptDetails() {
      const _this = this;
      this.loadingBox = true;
      manuscriptDetails({id: _this.manuscriptId}).then((res) => {
        if (res.code == 0) {
          _this.title = res.data.title;
          _this.createTime = new Date(res.data.time);
          _this.source = res.data.source;
          _this.abstractText = res.data.abstractText;
          console.log(res.data, 'ssssssssssssssss')
          res.data.mediaConfigRequests && res.data.mediaConfigRequests.forEach(element => {
            if (element.type == 1) {
              // 微信公共号
              _this.weiForm = element;
              if (element.mediaData) {
                _this.newSelectData = JSON.parse(element.mediaData);
              }
            }
            if (element.type == 2) {
              // 微信公共号
              _this.weiBoForm = element;
              if (element.mediaData) {
                _this.sinaWeiBoData = JSON.parse(element.mediaData);
              }
            }
          });

          // res.data.content = res.data.content.replaceAll('<font face="方正仿宋简体">','')
          // res.data.content = res.data.content.replaceAll('</font>','')
          // res.data.content = res.data.content.replaceAll('<font face="Times New Roman">','')
          // res.data.content = res.data.content.replaceAll('<o:p>','')
          // res.data.content = res.data.content.replaceAll('</o:p>','')
          // res.data.content = res.data.content.replaceAll('&ensp;','')
          // res.data.content = res.data.content.replaceAll('&quot;','')
          //this.editorData = res.data.content;
          this.txtUpdate = res.data.content;
          // if (this.ueditor) {
          //   this.$nextTick(() => {
              // this.editor.select([]);
              // this.editor.deleteFragment();
          //     this.editor.dangerouslyInsertHtml(this.txtUpdate);
          //   });
          // }
          // _this.htmlContent = res.data.content;
          _this.itemSiteIds = res.data.siteIds;
          _this.coverImg = res.data.coverImg;
          _this.relatedLinks = res.data.relatedLinks;
          _this.keyword = res.data.keyword;
          (_this.redirectUrl = res.data.redirectUrl),
              (_this.state = res.data.state);
          let Ids = [];
          if (res.data.columnId) {
            Ids = res.data.columnId.split(",");
          }
          Ids.map((item) => {
            _this.columnIds.push(Number(item));
          });
          let columnArr = [];
          if (res.data.columnName) {
            _this.columnData = JSON.parse(res.data.columnName); //res.data.columnName.split(",");
            // columnArr.map((item) => {
            //   _this.columnData.push({
            //     columnName: item,
            //   });
            // });
          }
          _this.LinkInfo = res.data.linksResponses;
          res.data.linksResponses &&  res.data.linksResponses.map((item) => {
            if (item.type == 1) {
              _this.customLinkList.push(item);
            } else {
              _this.LinkIds.push(item.maId);
            }
          });
          let arr = [];
          let array = [];
          res.data.createResponses && res.data.createResponses.forEach((item) => {
            arr[`${item.modelId}${item.type}${item.fieldId}`] = item;
            array[`${item.modelId}${item.type}${item.fieldId}`] = item;
            delete item.type;
          });
          _this.detailsData = array;
          _this.getModelByColumn(arr);
          if(_this.weiForm.imgType ===1){
            _this.weiForm.imgUrl = _this.coverImg;
          }
        }
      });
    },
     //稿件详情
    getManuscriptDetailsTwo() {
      const _this = this;
      this.loadingBox = true;
      selectManuscriptDetails({id: _this.manuscriptId}).then((res) => {
        if (res.code == 0) {
          _this.title = res.data.title;
          _this.createTime = new Date(res.data.time);
          _this.source = res.data.source;
          _this.abstractText = res.data.abstractText;
          console.log(res.data, 'ssssssssssssssss')
          res.data.mediaConfigRequests && res.data.mediaConfigRequests.forEach(element => {
            if (element.type == 1) {
              // 微信公共号
              _this.weiForm = element;
              if (element.mediaData) {
                _this.newSelectData = JSON.parse(element.mediaData);
              }
            }
            if (element.type == 2) {
              // 微信公共号
              _this.weiBoForm = element;
              if (element.mediaData) {
                _this.sinaWeiBoData = JSON.parse(element.mediaData);
              }
            }
          });

          // res.data.content = res.data.content.replaceAll('<font face="方正仿宋简体">','')
          // res.data.content = res.data.content.replaceAll('</font>','')
          // res.data.content = res.data.content.replaceAll('<font face="Times New Roman">','')
          // res.data.content = res.data.content.replaceAll('<o:p>','')
          // res.data.content = res.data.content.replaceAll('</o:p>','')
          // res.data.content = res.data.content.replaceAll('&ensp;','')
          // res.data.content = res.data.content.replaceAll('&quot;','')
          //this.editorData = res.data.content;
          this.txtUpdate = res.data.content;
          // if (this.ueditor) {
          //   this.$nextTick(() => {
              // this.editor.select([]);
              // this.editor.deleteFragment();
          //     this.editor.dangerouslyInsertHtml(this.txtUpdate);
          //   });
          // }
          // _this.htmlContent = res.data.content;
          _this.itemSiteIds = res.data.siteIds;
          _this.coverImg = res.data.coverImg;
          _this.relatedLinks = res.data.relatedLinks;
          _this.keyword = res.data.keyword;
          (_this.redirectUrl = res.data.redirectUrl),
              (_this.state = res.data.state);
          let Ids = [];
          if (res.data.columnId) {
            Ids = res.data.columnId.split(",");
          }
          Ids.map((item) => {
            _this.columnIds.push(Number(item));
          });
          let columnArr = [];
          if (res.data.columnName) {
            _this.columnData = JSON.parse(res.data.columnName); //res.data.columnName.split(",");
            // columnArr.map((item) => {
            //   _this.columnData.push({
            //     columnName: item,
            //   });
            // });
          }
          _this.LinkInfo = res.data.linksResponses;
          res.data.linksResponses &&  res.data.linksResponses.map((item) => {
            if (item.type == 1) {
              _this.customLinkList.push(item);
            } else {
              _this.LinkIds.push(item.maId);
            }
          });
          let arr = [];
          let array = [];
          res.data.createResponses && res.data.createResponses.forEach((item) => {
            arr[`${item.modelId}${item.type}${item.fieldId}`] = item;
            array[`${item.modelId}${item.type}${item.fieldId}`] = item;
            delete item.type;
          });
          _this.detailsData = array;
          _this.getModelByColumn(arr);
          if(_this.weiForm.imgType ===1){
            _this.weiForm.imgUrl = _this.coverImg;
          }
        }
      });
    },
    setFileUrl(urlString) {
      let resData = [];
      if (urlString) {
        urlString.map((item, index) => {
          if (item) {
            var encodedData = window.btoa(
                process.env.VUE_APP_Img_Ip + item.path
            ); // 编码
            let url =
                `${process.env.VUE_APP_Preview}?url=` + encodedData;
            resData.push({
              url: url,
              uid: index,
              name: item.name,
              status: "done",
            });
          }
        });
      }
      return resData;
    },
    colseChooseColumn() {
      this.isColumn = false;
    },
    deleteFn(index, key) {
      console.log(index, key, "这个key就没有了");
      this.columnIds.splice(this.columnIds.indexOf(key), 1);
      this.columnData.splice(index, 1);
      this.$nextTick(() => {
        this.$refs.chooseColumn.deleteFn(index, key);
      })
      if (this.columnIds.length > 0) {
        let oldData = JSON.parse(JSON.stringify(this.ModelColumns));
        let arr = [];
        if (oldData.length > 0) {
          oldData.forEach(element => {
            element.fieldResponse.fieldTextCreateRequests && element.fieldResponse.fieldTextCreateRequests.forEach((item) => {
              arr[`${item.id}${item.type}`] = item;
            });
            element.fieldResponse.fieldOptionCreateRequests && element.fieldResponse.fieldOptionCreateRequests.forEach((item) => {
              arr[`${item.id}${item.type}`] = item;
            });
            element.fieldResponse.fieldFileCreateRequests && element.fieldResponse.fieldFileCreateRequests.forEach((item) => {
              arr[`${item.id}${item.type}`] = item;
            });
            element.fieldResponse.dateCreateRequest && element.fieldResponse.dateCreateRequest.forEach((item) => {
              arr[`${item.id}${item.type}`] = item;
            });
            element.fieldResponse.indexRequests && element.fieldResponse.indexRequests.forEach((item) => {
              arr[`${item.id}${item.type}`] = item;
            });
          });
        }
        this.getModelByColumnTwo(this.columnIds, arr);
      } else {
        this.ModelColumns = [];
      }
    },
    weiBoDel(index) {
      this.sinaWeiBoData.splice(index, 1)
    },
    setColumnIds(data) {
      this.columnIds = data.columnIds;
      this.columnData = data.columnData;
      console.log(this.columnData,'xxxxxxxxxxxx')
      this.isColumn = false;
      let oldData = JSON.parse(JSON.stringify(this.ModelColumns));
      let arr = [];
      if (oldData && oldData.length > 0) {
        oldData.forEach(element => {
          element.fieldResponse.fieldTextCreateRequests && element.fieldResponse.fieldTextCreateRequests.forEach((item) => {
            arr[`${item.id}${item.type}`] = item;
          });
          element.fieldResponse.fieldOptionCreateRequests && element.fieldResponse.fieldOptionCreateRequests.forEach((item) => {
            arr[`${item.id}${item.type}`] = item;
          });
          element.fieldResponse.fieldFileCreateRequests && element.fieldResponse.fieldFileCreateRequests.forEach((item) => {
            arr[`${item.id}${item.type}`] = item;
          });
          element.fieldResponse.dateCreateRequest && element.fieldResponse.dateCreateRequest.forEach((item) => {
            arr[`${item.id}${item.type}`] = item;
          });
          element.fieldResponse.indexRequests && element.fieldResponse.indexRequests.forEach((item) => {
            arr[`${item.id}${item.type}`] = item;
          });
        });
      }
      this.getModelByColumnTwo(this.columnIds, arr);
    },
    deleteLinks(index) {
      if (this.LinkInfo[index].type != 1) {
        this.LinkIds.splice(index, 1);
        this.$nextTick(() => {
          this.$refs.chooseLink.deleteFn(index);
        })
      } else {
        this.$refs.chooseLink.deleteCustomLink2(this.LinkInfo[index]);
      }
      this.LinkInfo.splice(index, 1);
    },
    //编辑替换图片
    toEditImg() {
      this.resourceIsShow = true;
      this.$refs.chooseCover.toEditImg(this.coverImg);
    },
    deleteImg() {
      (this.coverImg = ""), this.$refs.chooseCover.deleteImg();
    },
    closeImport() {
      this.importIsShow = false;
    },
    toHistory() {
      this.historyIsShow = true;
      this.$refs.history.getList();
    },
    beforeUploadFile(file) {
      let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (this.importType == 1) {
        if (suffix != "doc" && suffix != "docx") {
          message.error("只能上传doc或者docx文件");
          return;
        }
      }
      if (this.importType == 2) {
        if (suffix != "xlsx"&&suffix != "xls") {
          message.error("只能上传xlsx或者xls文件");
          return;
        }
      }
      if (this.importType == 3) {
        if (suffix != "pdf") {
          message.error("只能上传pdf文件");
          return;
        }
      }
      if (this.importType == 4) {
        if (suffix != "pptx"&&suffix != "ppt") {
          message.error("只能上传pptx或者ppt文件");
          return;
        }
      }
      this.importFile = file;
      this.fileListExple = [file];
      return false;
    },
    closeHistory() {
      this.historyIsShow = false;
    },
    //关键词提取
    getKeyWords() {
      let text = "";
      text = this.getSimpleText(this.htmlContent);
      keyWordsExtract({text: text}).then((res) => {
        if (res.code == 0) {
          this.keyword = res.data.keyWords;
        }
      });
    },
    getSimpleText(html) {
      var re1 = new RegExp("<.+?>", "g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var res = html.replace(re1, ""); //执行替换成空字符
      res.replace(/&nbsp;/g, "");
      return res;
    },
    //打开错敏检测页面
    openMisse() {
      this.misseIsShow = true;
      // this.$nextTick(() => {
      //   this.$refs.missensity.toCorrectionExtract();
      // });
    },
    closeMisse() {
      this.misseIsShow = false;
    },
    saveMisse(html) {
      this.htmlContent = html;
      this.misseIsShow = false;
    },
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
/deep/ .ant-spin-dot {
  display: inline-block;
  font-size: 20px;
  width: 1em;
  height: 1em;
  position: absolute;
  left: 50%;
  bottom: 50%;
}

/deep/ .ant-spin-container {
  position: static;
}

/deep/ .ant-spin-nested-loading {
  position: static;
}

.top {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: sticky;
  top: 0;
  width: 100%;
  padding-left: 200px;
  background: #fff;
  z-index: 99;

  .back {
    height: 30px;
    width: 30px;
    line-height: 30px;
    background-color: #f5f5f5;
    /* margin: 20px; */
    border-radius: 50%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    /* padding: 20px; */
    /* padding: 10px 20px; */
    margin: 10px 20px;

    /deep/ .anticon {
      width: 30px;
    }
  }
}

.content {
  width: 100%;
  height: 100%;
  background: #f0f2f5;
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  overflow-y: auto;

  .set-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;

    .line {
      width: 40%;
      height: 2px;
      background: #eeebeb;
    }
  }

  .left {
    .btn-item {
      width: 118px;
      height: 52px;
      line-height: 52px;
      background: #fff;
      margin-right: 10px;
      text-align: center;
      font-size: 14px;
      box-sizing: border-box;
      margin-bottom: 10px;
      cursor: pointer;
    }
  }

  .middle {
    width: 70%;
    background: #fff;
    max-width: 1000px;

    .t-title {
      padding: 20px 62px;

      .title {
        /deep/ .el-input {
          border-bottom: 1px solid #eeebeb;
          padding: 10px 0;
        }

        /deep/ .el-input__inner {
          border: none;
          color: #415058;
          font-size: 21px;
          font-weight: bold;
        }

        /deep/ input::-webkit-input-placeholder {
          color: #415058;
          font-size: 21px;
          font-weight: bold;
        }
      }

      .info {
        display: flex;
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px solid #eeebeb;

        /deep/ .el-input__inner {
          border: none;
        }

        /deep/ input::-webkit-input-placeholder {
          color: #415058;
          font-size: 14px;
        }

        /deep/ .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
          width: 180px;
        }

        /deep/ .el-input {
          width: 70%;
        }
      }

      .abstract {
        padding: 10px 0;
        border-bottom: 1px solid #eeebeb;

        /deep/ input::-webkit-input-placeholder {
          color: #415058;
          font-size: 14px;
        }

        /deep/ .el-input__inner {
          border: none;
        }
      }
    }

    .setup {
      /deep/ input::-webkit-input-placeholder {
        color: #415058;
        font-size: 12px;
      }

      /deep/ .el-form-item__label {
        text-align: left;
      }

      .one-box {
        text-align: center;
        width: 150px;
        height: 120px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border: 1px dashed #eeebeb;
        padding-top: 30px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon-plus {
          font-size: 20px;
        }

        .text {
          // margin-top: 6px;
          color: #afaeae;
        }

        .edit-image {
          position: absolute;
          background: #858383;
          width: 50%;
          height: 30px;
          line-height: 30px;
          margin: 0 auto;
          border-radius: 5px;
          cursor: pointer;
          bottom: 8px;
          right: 25%;
          // margin-left: -30px;
          color: #fff;
          font-size: 12px;
        }

        .semi-close {
          position: absolute;
          top: -12px;
          right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          cursor: pointer;
        }

        img {
           max-width: 100%;
           max-height: 100%;
        }
      }

      .one-box-two {
        padding: 0;
        position: relative;
      }

      .one {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        color: #1890ff;
        background: #ecf5ff;
        margin: 5px 5px;
        border-radius: 5px;

        .name {
          font-weight: 400;
          width: 90%;
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap;  // 默认不换行；
        }

        .icon-close:before {
          color: #1890ff;
          position: relative;
          cursor: pointer;
        }

        .icon-st-doc-edit:before {
          color: #1890ff;
        }
      }
    }
  }

  .right {
    background: #fff;
    margin-left: 10px;
    // min-width: 200px;
    max-width: 420px;
    flex: 1;
    // /deep/.is-top{
    //     padding: 10px;
    // }
    /deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
      padding-right: 16px;
    }

    /deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
      padding-left: 16px;
    }

    .acc-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 20px 0;
    }

    .el-upload-list__item-thumbnail {
      width: 148px;
      height: 148px;
    }

    .ant-input {
      // width: 200px;
      margin: 0 8px 8px 0;
      font-size: 14px;
    }
  }
}

.setup-bt {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 15px 20px;
  /* height: 40px; */
  border-top: solid 1px #e9e9e9;
  position: absolute;
  bottom: 0px;
  width: 100%;
  background: #fff;

  .doc-set {
    display: flex;
    align-items: center;

    /deep/ .el-button {
      border: none;
    }
  }

  .icon-edit-preview:before {
    color: #1890ff;
  }
}

.middle-box {
  background: #fff;
}

/deep/ .el-tabs {
  background: #fff;
  padding-bottom: 40px;
}

.setup-bt-btn {
  display: flex;
}

.setup-bt-btn {
  display: flex;
  justify-content: space-between;
  width: 70%;
  max-width: 1000px;
}

.setup-bt-two {
  max-width: 420px;
  margin-left: 10px;
  flex: 1;
}

.setup-bt-one {
  width: 118px;
}

.tabs-box {
  display: flex;
  border-bottom: 1px solid rgba(217, 217, 217, 1);
  justify-content: space-between;
  padding: 27px 30px;
  padding-bottom: 17px;
}

.tabs-dir {
  height: 4px;
  background: #1890ff;
  width: 140%;
  position: absolute;
  bottom: -17px;
  left: -10px;
}

.menhu {
  position: relative;
  cursor: pointer;
  flex: 1;
  margin-right: 30px;
  text-align: center;
}

.menhu:last-child {
  margin-right: 12px;
}

.item-error {
  height: 20px;
  color: red;
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-input__inner {
  width: 100%;
}

.item-box-one {
  display: flex;
}

.label-box {
  width: 120px;
}

.dantu-upload {
  /deep/ .el-upload--picture-card {
    margin-left: 19px;
    margin-bottom: 18px;
  }
}

/deep/ .el-dialog__title {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}

/deep/ .el-dialog__close {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}

.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 24px;
}

.column-box {
  /deep/ .el-dialog__body {
    padding-bottom: 8px !important;
  }
}

.acc-list {
  /deep/ .icon-close:before {
    position: relative;
    cursor: pointer;
  }
}

/deep/ .icon-close:before {
  position: relative;
  cursor: pointer;
  width: 12px;
  height: 12px;
  z-index: 1;
}

.dantu-yan {
  margin-right: 10px;
  position: absolute;
  top: 94px;
}

/deep/ .anticon-down {
  font-size: 12px;
}

/deep/ .anticon-up {
  margin-left: 5px;
  font-size: 13px;
}

/deep/ .edui-default .edui-editor-toolbarbox {
  position: sticky;
  top: -10px;
  z-index: 9999
}

/deep/ .edui-default .edui-editor-iframeholder, .edui-default .edui-editor-iframeholder iframe {
  max-height: 100vh;
  min-height: 400px;
}
.title-box {
  padding:0 5px;
  display: flex;
  align-items: center;
  border-radius: 2px;
  background-color: rgba(103, 194, 58, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  text-align: center;
  margin: 5px;
}
.radio-box{
   /deep/ .el-radio{
    margin-bottom: 10px;
   }
}
.link-box{
    .name{
      display: flex;
      height: 22px;
      align-items: center;
      width: 100%;
    }
    .link-txt{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.editor-box{
      min-height:400px;
      padding: 0 62px
  }
  .form-box{
    padding: 10px 62px;
  }
  @media screen and (max-width: 1300px) {
     .middle{
      width: 56% !important;
     }
      /deep/ .edui-editor{
        z-index: 0 !important;
      }
       .editor-box{
          min-height:400px;
          padding: 0 12px
      }
  }
@media screen and (max-width: 900px) {
  .top{
     padding-left: 0px;
  }
  .middle{
      width: auto !important;
     }
  .tabs-dir{
    height: 4px;
    background: #1890ff;
    position: absolute;
    bottom: -17px;
    width: 90%;
    left: 10px;
  }
  .setup-bt-btn {
      //display: block;
      width: auto;
    }
  .content{
     display:block;
     .middle{
      width: auto;
     }
  }
  .content .middle .t-title .info{
       display:block;
  }
  .left{
    display: flex;
    flex-wrap: wrap;
    &::after{
      content: '';
      flex: 1;
    }
  }
  
  /deep/ .edui-editor{
    z-index: 0 !important;
  }
  .btn-item{
    width: 114px !important;
  }
  .editor-box{
      min-height:400px;
      padding: 0 12px
  }
  .content .right{
    margin-left: 0px;
    margin-top: 20px;
    padding-bottom: 130px;
    max-width: 100%;
  }
  .setup{
    margin-top: 20px;
  }
  /deep/ .el-button--medium {
    padding: 10px 14px;
  }
  .cg-box{
    padding: 0px;
    margin-right: 20px;
  }
  .btn-box{
    margin-left: 20px;
  }
  .setup-bt-one{
    width: auto;
  }
  .setup-bt{
    bottom: 0px;
    position: fixed;
}
}
@media screen and (max-width: 720px) {
   .content{
     height: 100vh !important;
  }
  .tabs-dir{
    height: 4px;
    background: #1890ff;
    position: absolute;
    bottom: -17px;
    width: 120%;
    left: -5px;
  }
  .btn-box{
    margin-top: 12px;
    margin-left: 0px;
  }
   .setup-bt-btn {
      display: block;
    }
    .form-box{
      padding: 10px 10px 10px 0px;
    }
    /deep/ .el-form-item__label{
      text-align: center !important;
    }
     .t-title{
      padding: 20px 12px !important;
    }
    .lai-yuan{
      margin-left: 14px;
    }
}
.img-box {
  width: 150px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-img {
  width: auto !important;
  height: auto !important;
  max-width: 100%;
  max-height: 100%;
}
.semi-close {
          position: absolute;
          top: -12px;
          right: 5px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          cursor: pointer;
        }

.template_modal /deep/  .ant-modal-footer{
  display: none;
}
</style>